import Vue from 'vue'
import { PAYMENTS_TYPES } from '@/pages/Finance/Orders/payments-types'

Vue.config.server = process.env.SERVER
Vue.config.notifyServer = process.env.NOTIFY_SERVER
Vue.config.cdnServer = process.env.CDN_SERVER || 'https://cdn.pilki.com'
Vue.config.dadataServer = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest'

Vue.config.dadataApiKey = 'dfa526054eb6a12db540afcea4204bb31eefe8b2'
Vue.config.VIEW_DATEPICKER = 0
Vue.config.VIEW_DATEPICKER_MONTH = 1
Vue.config.VIEW_SELECT = 2
Vue.config.VIEW_TEXTFIELD = 3

Vue.config.VUE_APP_PROMO_CODE_SERVER = process.env.VUE_APP_PROMO_CODE_SERVER

// @TODO Переделать на статусы с бэкенда
const TICKETS_STATUSES = {
  ASKED: '0',
  ANSWERED: '1',
  RESOLVED: '2',
  STATUS_NEED_INFO: '3',
  DUPLICATE: '4',
  PROCESS: '5',
  PROPOSAL: '6',
  REJECTED: '7',
}
const TICKETS_STATUSES_TITLES = {
  [TICKETS_STATUSES.ASKED]: 'Ожидает ответа',
  [TICKETS_STATUSES.ANSWERED]: 'Получен ответ',
  [TICKETS_STATUSES.STATUS_NEED_INFO]: 'Необходима доп. информация',
  [TICKETS_STATUSES.RESOLVED]: 'Вопрос решен',
  [TICKETS_STATUSES.REJECTED]: 'Отклонен',
  [TICKETS_STATUSES.DUPLICATE]: 'Дубликат',
  [TICKETS_STATUSES.PROCESS]: 'В процессе решения',
  [TICKETS_STATUSES.PROPOSAL]: 'Предложение',
}
const PAYMENT_STATUSES = {
  STATUS_NEW: 0,
  STATUS_CANCEL: 1,
  STATUS_PAYED: 2,
  STATUS_DONE: 3,
  STATUS_REFUND: 4,
}
const PAYMENT_STATUSES_TITLES = {
  [PAYMENT_STATUSES.STATUS_NEW]: 'Новый',
  [PAYMENT_STATUSES.STATUS_CANCEL]: 'Отменен',
  [PAYMENT_STATUSES.STATUS_PAYED]: 'Оплачен',
  [PAYMENT_STATUSES.STATUS_DONE]: 'Завершен',
  [PAYMENT_STATUSES.STATUS_REFUND]: 'Возврат',
}
const PAYMENT_TYPES = {
  CASH: 8,
  CARD: 1,
  ONLINE: 2,
  CERT: 3,
  BY_EMPLOYER: 4,
  BY_COMPANY: 5,
  CLUB_CARD: 7,
  SBER_QR: 10,
  TINKOFF_QR: 11,
  SELF_EMPLOYED: 16,
  PROMO_CODE: 17,
}
const PAYMENT_TYPES_TITLES = {
  [PAYMENTS_TYPES.PAYMENT_TYPE_CASH]: 'Наличная оплата',
  [PAYMENTS_TYPES.PAYMENT_TYPE_CARD]: 'Безналичная оплата',
  [PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_ONLINE]: 'Онлайн-оплата',
  [PAYMENTS_TYPES.PAYMENT_TYPE_CERTIFICATE]: 'Сертификат',
  [PAYMENTS_TYPES.PAYMENT_TYPE_EMPLOYER_PAY]: 'За счет мастера',
  [PAYMENTS_TYPES.PAYMENT_TYPE_COMPANY_PAY]: 'За счет компании',
  [PAYMENTS_TYPES.PAYMENT_TYPE_CLUB_CARD]: 'Клубная карта',
  [PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_QR]: 'Тинькофф QR',
  [PAYMENTS_TYPES.PAYMENT_TYPE_SELF_EMPLOYED]: 'Самозанятые. Наличные',
  [PAYMENTS_TYPES.PAYMENT_TYPE_PROMO_CODE]: 'Промокод',
  [PAYMENTS_TYPES.PAYMENT_TYPE_SBER_QR]: 'Сбербанк QR',
}

export const PAYMENT_TYPES_OBJECT = [
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CASH, title: 'Наличная оплата' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_ONLINE, title: 'Безналичная оплата' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CERTIFICATE, title: 'Сертификат' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_EMPLOYER_PAY, title: 'За счет мастера' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_COMPANY_PAY, title: 'За счет компании' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_SBER_QR, title: 'Сбербанк QR' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CLUB_CARD, title: 'Клубная карта' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_QR, title: 'Тинькофф QR' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_SELF_EMPLOYED, title: 'Самозанятые. Наличные' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_PROMO_CODE, title: 'Промокод' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CARD, title: 'Безналичная оплата' },
]

export const PAYMENT_TYPES_OBJECT_FILTER = [
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CASH, title: 'Наличная оплата' },
  {
    id: `${PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_ONLINE},${PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_CREDIT_FOR_3_MONTHS},${PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_CREDIT_FOR_4_MONTHS},${PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_CREDIT_FOR_6_MONTHS}`,
    title: 'Картой сервиса Тинькоф',
  },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CERTIFICATE, title: 'Сертификат' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_EMPLOYER_PAY, title: 'За счет мастера' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_COMPANY_PAY, title: 'За счет компании' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_SBER_QR, title: 'Сбербанк QR' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CLUB_CARD, title: 'Клубная карта' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_TINKOFF_QR, title: 'Тинькофф QR' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_SELF_EMPLOYED, title: 'Самозанятые. Наличные' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_PROMO_CODE, title: 'Промокод' },
  { id: PAYMENTS_TYPES.PAYMENT_TYPE_CARD, title: 'Безналичная оплата' },
]

const FEEDBACK_STATUSES = {
  todo: { id: 1, title: 'Сделать' },
  in_progress: { id: 2, title: 'В процессе' },
  completed: { id: 3, title: 'Выполнено' },
  rejected: { id: 4, title: 'Отклонённый' },
}
const CLAIM_STATUSES = {
  alarm: { id: 5, title: 'Срочно связаться' },
  todo: { id: 1, title: 'Сделать' },
  in_progress: { id: 2, title: 'В процессе' },
  completed: { id: 3, title: 'Выполнено' },
  rejected: { id: 4, title: 'Отклонённый' },
}
const BOOKING_SOURCE = [
  { id: 1, name: 'CRM' },
  { id: 2, name: 'Сайт' },
  { id: 3, name: 'Приложение Пилки' },
  { id: 4, name: 'Планшет' },
]

const TYPE_NOTIFICATIONS = {
  EMPLOYER: 'App\\Notifications\\System123Message',
  EMPLOYER_COMPLETE: 'App\\Notifications\\System123CompletedMessage',
  INTERVIEW: 'App\\Notifications\\InterviewMessage',
  TICKET: 'App\\Notifications\\TicketNewMessageMessage',
  GOOD_ORDER: 'App\\Notifications\\GoodOrderAlertMessage',
  GOOD_FLOW: 'App\\Notifications\\GoodFlowAlertMessage',
  TICKET_CREATED_MESSAGE: 'App\\Notifications\\TicketCreatedMessage',
  CREATE_ORDER_TABLET: 'App\\Notifications\\AutomaticallyCreatedOrder',
  GENERATE_CERTIFICATE: 'App\\Notifications\\CertificatesGenerate',
  EXCEL_BOOKING: 'App\\Notifications\\WindowExportSuccess',
  NEWS: 'App\\Notifications\\EmployerNewsNotification',
}

const ORDER_ITEM_TYPES = {
  SERVICE: 'App\\Models\\Service',
  CERTIFICATE: 'App\\Models\\Certificate',
  GOOD: 'App\\Models\\Good',
  CLUB_CARD: 'App\\Models\\ClubCard',
}

const ORDER_ITEM_TYPE_TITLES = [
  { id: ORDER_ITEM_TYPES.SERVICE, title: 'Услуга' },
  { id: ORDER_ITEM_TYPES.CERTIFICATE, title: 'Сертификат' },
  { id: ORDER_ITEM_TYPES.GOOD, title: 'Товар' },
  { id: ORDER_ITEM_TYPES.CLUB_CARD, title: 'Клубная карта' },
]

const ORDER_DONE_STATUSES = [
  { value: '0,1,2,4', key: 'Не проведено' },
  { value: '3', key: 'Проведено' },
]

const ORDER_PAYMENT_STATUSES = [
  {
    text: 'Новая',
    id: 'user_pending',
  },
  {
    text: 'Обработка платежа',
    id: 'provider_pending',
  },
  {
    text: 'Успешная',
    id: 'success',
  },
  {
    text: 'Неуспешная',
    id: 'fail',
  },
  {
    text: 'Возврат',
    id: 'refund',
  },
  {
    text: 'Отмена',
    id: 'cancel',
  },
]

const PERMISSIONS_CONSTANTS = {
  CREATE_UPDATE_WITH_TIME_FINGERPRINT: 'App\\Models\\EmployerFingerprintCheckin.create_update_with_time',
  CALENDAR: 'App\\Models\\Window.calendar',
  CUSTOMERS: 'App\\Models\\User.view',
  NEW_CUSTOMER: 'App\\Models\\User.create_child',
  CUSTOMER: 'App\\Models\\User.view',
  CUSTOMER_UPDATE: 'App\\Models\\User.update',
  CUSTOMER_DELETE: 'App\\Models\\User.delete',
  CUSTOMER_RESTORE: 'App\\Models\\User.restore',
  CUSTOMER_SHOW_PHONE: 'App\\Models\\User.show_phone',
  CUSTOMER_PHONE_CHANGE: 'App\\Models\\User.change_phone',
  CUSTOMER_BLOCK: 'App\\Models\\User.can_block',
  BOOKINGS: 'App\\Models\\Booking.view',
  NEW_BOOKING: 'App\\Models\\Booking.create_child',
  BOOKING: 'App\\Models\\Booking.view',
  WAITING_LIST: 'App\\Models\\WaitingListBooking.view',
  BOOKING_STATUS_CANCEL: 'App\\Models\\Booking.status_cancel',
  BOOKING_SECRET: 'App\\Models\\Booking.secret_client',
  BOOKING_NEAREST: 'App\\Models\\Booking.nearest_units',
  PHOTO_WORK: 'App\\Models\\Image.view',
  EMPLOYEES: 'App\\Models\\Employer.view',
  EMPLOYER_SERVICE_TEMPLATE: 'App\\Models\\Employer.service_template',
  EMPLOYER_SERVICE_CONTROL: 'App\\Models\\Employer.services.control',
  EMPLOYER_NEW_MASTER_VIEW: 'App\\Models\\Review.new_master:view',
  NEW_EMPLOYEE: 'App\\Models\\Employer.create_child',
  EMPLOYEE: 'App\\Models\\Employer.view',
  EMPLOYEE_UPDATE: 'App\\Models\\Employer.update',
  EMPLOYEE_RESTORE: 'App\\Models\\Employer.restore',
  EMPLOYER_SELF: 'App\\Models\\Employer.self_employed:add',
  EMPLOYER_EDIT_PORTFOLIO_UNTIL: 'App\\Models\\Employer.portfolio_set_until:edit',
  CERTIFICATE: 'App\\Models\\Certificate.view',
  CERTIFICATE_INVENT: 'App\\Models\\Certificate.invent_all',
  CERTIFICATE_STORE: 'App\\Models\\Certificate.invent_store',
  CERTIFICATE_VIEW: 'App\\Models\\Certificate.invent_view',
  CERTIFICATE_REDEEM_SAME_DAY: 'App\\Models\\Certificate.redeem_same_day',
  EXCHANGE_VIEW: 'App\\Models\\ExchangeSum.view',
  EXCHANGE_UPDATE: 'App\\Models\\ExchangeSum.update',
  EXCHANGE_CREATE: 'App\\Models\\ExchangeSum.create_child',
  CERTIFICATE_MANUAL_INPUT: 'App\\Models\\Certificate.manual_input',
  CERTIFICATE_RECONCILIATION_VIEW: 'App\\Models\\Certificate.reconciliation_view',
  CERTIFICATE_RECONCILIATION_EDIT: 'App\\Models\\Certificate.reconciliation_edit',
  PUSH: 'PUSH',
  SALARY: 'App\\Models\\Salary.view',
  CANDIDATES: 'candidates',
  SERVICES: 'App\\Models\\Service.view',
  PARTNERS_VIEW: 'App\\Models\\PARTNERS.view',
  PARTNERS_ACTION: 'App\\Models\\PARTNERS.action',
  RESIZE_BOOKING: 'App\\Models\\Window.resize_booking',
  BLOCK_WINDOW: 'App\\Models\\Window.block_window',
  RESTORE_WINDOW: 'App\\Models\\Window.restore_window',
  NEW_SERVICES: 'App\\Models\\Service.create_child',
  NEW_SERVICE_CATEGORY: 'new-service-category',
  SERVICE_CATEGORY: 'service-category',
  SERVICE: 'App\\Models\\Service.view',
  SERVICE_TEMPLATES: 'App\\Models\\Service.service-templates',
  WORK_POSITIONS_VIEW: 'App\\Models\\WorkPosition.view',
  WORK_POSITIONS_PERMISSION: 'App\\Models\\WorkPosition.permissions',
  WORK_POSITIONS_UPDATE: 'App\\Models\\WorkPosition.update',
  WORK_POSITIONS_MANAGE_SUPERUSER: 'App\\Models\\WorkPosition.manage_superusers',
  WORK_POSITIONS: 'work-positions',
  NEW_WORK_POSITION: 'new-work-position',
  WORK_POSITION: 'work-position',
  UNITS: 'units',
  UNITS_VIEW: 'App\\Models\\Unit.view',
  UNITS_CREATE: 'App\\Models\\Unit.update',
  UNIT_IMAGE_EDIT: 'App\\Models\\Unit.image_edit',
  UNIT_GEOLOCATION_EDIT: 'App\\Models\\Unit.geolocation_edit',
  UNIT_NEIGHBOURS_EDIT: 'App\\Models\\Unit.neighbours_edit',
  NEW_UNIT: 'new-unit',
  UNIT: 'unit',
  UNIT_SETTINGS: 'App\\Models\\Unit.settings',
  UNIT_PILO4KI_SETTINGS_EDIT: 'App\\Models\\Unit.unit_promo_settings_edit',
  WORK_PLACES_INTERVALS: 'work-places-intervals',
  LIST_ACTIVE_FINGERPRINT: 'App\\Models\\Employer.fingerprint-check-in',
  LOGS: 'logs',
  SCHEDULE: 'App\\Models\\EmployerSchedule.view',
  SCHEDULE_EDIT: 'App\\Models\\EmployerSchedule.update',
  SCHEDULE_EDIT_IN_PAST: 'App\\Models\\EmployerSchedule.edit-in-past',
  CHAT: 'chat',
  TELEPHONY: 'telephony',
  EMPLOYER_RATING_CHANGES: 'App\\Models\\Employer.change_rating',
  EMPLOYER_FIRE: 'App\\Models\\Employer.employer_fire',
  EMPLOYER_PERMISSION_TAB: 'App\\Models\\Employer.permission_tab',
  EMPLOYER_EDIT_UNIT: 'App\\Models\\Employer.company_id:edit',
  EMPLOYER_SALARY_BASE_VIEW: 'App\\Models\\EmployerSalaryBase.view',
  EMPLOYER_SALARY_BASE_UPDATE: 'App\\Models\\EmployerSalaryBase.update',
  EMPLOYER_SALARY_BASE_DELETE: 'App\\Models\\EmployerSalaryBase.delete',
  EMPLOYER_ACCESS_CHANGE: 'App\\Models\\Employer.change_access',

  EMPLOYER_ABSENCE_UPDATE: 'App\\Models\\EmployerAbsenceWork.update',
  EMPLOYER_ABSENCE_VIEW: 'App\\Models\\EmployerAbsenceWork.view',
  EMPLOYER_ABSENCE_CREATE: 'App\\Models\\EmployerAbsenceWork.create_child',
  EMPLOYER_ABSENCE_DELETE: 'App\\Models\\EmployerAbsenceWork.delete',

  EMPLOYER_PERSONAL_INFO_CHANGE: 'App\\Models\\Employer.change_personal_info',
  EMPLOYER_STATUSES: 'App\\Models\\Employer.lord_of_statuses',
  EMPLOYER_DELETE: 'App\\Models\\Employer.delete',
  EMPLOYER_EDIT_VOTE: 'App\\Models\\Employer.employer_edit_vote',
  COMPANY_VIEW: 'App\\Models\\Company.view',
  COMPANY_PROMO_SETTINGS_VIEW: 'App\\Models\\Company.company_promo_settings_view',
  COMPANY_PROMO_SETTINGS_EDIT: 'App\\Models\\Company.company_promo_settings_edit',
  COMPANY_PROMO_SETTINGS_COPY_COMPANY: 'App\\Models\\Company.company_promo_settings_copy_company',
  COMPANY_PROMO_SETTINGS_DELETE: 'App\\Models\\Company.company_promo_settings_delete',
  COMPANY_USERS_IMPORT: 'App\\Models\\Company.company_users_import',
  COMPANY_SETTINGS_CHANGE_SERVICES: 'App\\Models\\Company.company_active_services_edit',
  ORDER_CREATE: 'App\\Models\\Order.create_child',
  ORDER_RETURN_CHECK: 'App\\Models\\Order.refund',
  ORDER_RETURN_CLOSE: 'App\\Models\\Order.close',
  ORDER_EDIT_RECLAMATION: 'App\\Models\\Order.edit_reclamation',
  ORDER_CHANGE_DATES: 'App\\Models\\Order.change_date',
  ORDER_CHANGE_PRICES: 'App\\Models\\Order.change_prices',
  ORDER_CHANGE_CREATOR: 'App\\Models\\Order.change_admin',
  ORDER_CANCEL_STATUS: 'App\\Models\\Order.cancel',
  ORDER_CHANGE_USER: 'App\\Models\\Order.change_user',
  ORDER_CHANGE_MASTER: 'App\\Models\\Order.change_master',
  ORDER_FORCE_CLOSE: 'App\\Models\\Order.close_force',
  ORDER_AUDIT_VIEW: 'App\\Models\\Order.audit_view',
  ORDER_PAYMENT_BY_COMPANY: 'App\\Models\\Order.payment_type_recl_company',
  EMPLOYER_PHONE_CHANGE: 'App\\Models\\Employer.change_phone',
  EMPLOYER_FOR_RESERVE: 'App\\Models\\Employer.for_reserve',
  ANALYTICS: 'App\\Models\\AnalyticsReports.allow',
  NEW_ANALYTICS: 'App\\Models\\AnalyticsReports.allow',
  ANALYTICS_SHOW_MORE_DAYS: 'App\\Models\\AnalyticsData.more_days',
  ANALYTIC: 'analytic',
  CALL_CENTER: 'call-center',
  STORAGE: 'storage',
  SCHOOL: 'pilki-school',
  AFFILIATES: 'affiliates',
  ACCOUNT_SETTINGS: 'App\\Models\\Employer.view',
  SYSTEM_SETTINGS: 'system-settings',
  COMPANY_SETTINGS: 'company-settings',
  CONTRACTORS: 'App\\Models\\Contractor.view',
  CONTRACTORS_ADD: 'App\\Models\\Contractor.create_child',
  CONTRACTORS_UPDATE: 'App\\Models\\Contractor.update',
  CONTRACTORS_REMOVE: 'App\\Models\\Contractor.delete',
  REQUEST: 'request',
  GOODS: 'App\\Models\\Good.view',
  PRODUCT: 'App\\Models\\Good.view',
  UPD_PRODUCT: 'App\\Models\\Good.update',
  NEW_PRODUCT: 'App\\Models\\Good.create_child',
  DEL_PRODUCT: 'App\\Models\\Good.delete',
  PRODUCTS_GROUPS: 'App\\Models\\GoodGroup.view',
  PRODUCTS_GROUP: 'App\\Models\\GoodGroup.view',
  UPD_PRODUCTS_GROUP: 'App\\Models\\GoodGroup.update',
  NEW_PRODUCTS_GROUP: 'App\\Models\\GoodGroup.create_child',
  DEL_PRODUCTS_GROUP: 'App\\Models\\GoodGroup.delete',
  PRODUCTS_FLOW: 'App\\Models\\GoodFlow.view',
  PRODUCT_FLOW: 'App\\Models\\GoodFlow.view',
  UPD_PRODUCT_FLOW: 'App\\Models\\GoodFlow.update',
  NEW_PRODUCT_FLOW: 'App\\Models\\GoodFlow.create_child',
  DEL_PRODUCT_FLOW: 'App\\Models\\GoodFlow.delete',
  DEL_AUTOMATIC_PRODUCT_FLOW: 'App\\Models\\GoodFlow.delete_automatic',
  EXEC_PRODUCT_FLOW: 'App\\Models\\GoodFlow.execute',
  RESTORE_PRODUCT_FLOW: 'App\\Models\\GoodFlow.restore',
  ACCEPT_PRODUCT_FLOW: 'App\\Models\\GoodFlow.accept',
  PRODUCTS_REMAINS: 'App\\Models\\GoodRemain.view',
  PRODUCTS_REMAIN: 'App\\Models\\GoodRemain.view',
  DEL_PRODUCTS_REMAIN: 'App\\Models\\GoodRemain.delete',
  PRODUCTS_USAGE: 'App\\Models\\GoodGive.view',
  PRODUCT_USAGE: 'App\\Models\\GoodGive.view',
  UPD_PRODUCT_USAGE: 'App\\Models\\GoodGive.update',
  NEW_PRODUCT_USAGE: 'App\\Models\\GoodGive.create_child',
  DEL_PRODUCT_USAGE: 'App\\Models\\GoodGive.delete',
  FIX_PRODUCT_USAGE: 'App\\Models\\GoodGive.correct',
  PRODUCT_INVOICE: 'App\\Models\\GoodInvoice.view',
  PRODUCT_INVOICES: 'App\\Models\\GoodInvoice.view',
  UPD_PRODUCT_INVOICE: 'App\\Models\\GoodInvoice.update',
  NEW_PRODUCT_INVOICE: 'App\\Models\\GoodInvoice.create_child',
  DEL_PRODUCT_INVOICE: 'App\\Models\\GoodInvoice.delete',
  PRODUCT_INVENT: 'App\\Models\\GoodInvent.view',
  PRODUCT_INVENTS: 'App\\Models\\GoodInvent.view',
  UPD_PRODUCT_INVENT: 'App\\Models\\GoodInvent.update',
  NEW_PRODUCT_INVENT: 'App\\Models\\GoodInvent.create_child',
  REFRESH_PRODUCT_INVENT: 'App\\Models\\GoodInvent.refresh',
  DELETE_PRODUCT_INVENT: 'App\\Models\\GoodInvent.delete',
  PRODUCT_ORDER: 'App\\Models\\GoodOrder.view',
  PRODUCT_ORDERS: 'App\\Models\\GoodOrder.view',
  EQUIPMENT_TYPE: 'App\\Models\\Equipment\\EquipmentType.view',
  EQUIPMENT_TYPES: 'App\\Models\\Equipment\\EquipmentType.view',
  NEW_EQUIPMENT_TYPE: 'App\\Models\\Equipment\\EquipmentType.create_child',
  UPD_EQUIPMENT_TYPE: 'App\\Models\\Equipment\\EquipmentType.update',
  DELETE_EQUIPMENT_TYPE: 'App\\Models\\Equipment\\EquipmentType.delete',
  UPD_PRODUCT_ORDER: 'App\\Models\\GoodOrder.update',
  NEW_PRODUCT_ORDER: 'App\\Models\\GoodOrder.create_child',
  RKO: 'App\\Models\\CashOrder.rko.view',
  PKO: 'App\\Models\\CashOrder.pko.view',
  ZP: 'App\\Models\\Salary.view',
  ZP_DECLINE_ACCEPT_SALARY: 'App\\Models\\Salary.decline_accept_salary',
  REMOVE_CASH_ORDER: 'App\\Models\\CashOrder.delete',
  REMOVE_RKO_CASH_ORDER: 'App\\Models\\CashOrder.rko.delete',
  REMOVE_PKO_CASH_ORDER: 'App\\Models\\CashOrder.pko.delete',
  EDIT_RKO_CASH_ORDER: 'App\\Models\\CashOrder.rko.update',
  VIEW_RKO_CASH_ORDER: 'App\\Models\\CashOrder.rko.view',
  OU: 'App\\Models\\Order.view',
  OU_EDIT_DONE: 'App\\Models\\Order.edit_done',
  OU_EDIT_DONE_AFTER: 'App\\Models\\Order.update_after',
  EMPLOYER_FINGERPRINT_CHECKIN: 'App\\Models\\EmployerFingerprintCheckin.create_update_with_time',
  SMS_HISTORY: 'sms-history',
  NOTIFICATIONS: 'notifications',
  NOTIFICATIONS_NEWS_VIEW: 'App\\Models\\EmployerNews.view',
  NOTIFICATIONS_NEWS_EDIT: 'App\\Models\\EmployerNews.update',
  NOTIFICATIONS_NEWS_CREATE: 'App\\Models\\EmployerNews.create_child',
  PROMOTION_VIEW: 'App\\Models\\Promotion.view',
  PROMOTION_UPDATE: 'App\\Models\\Promotion.update',
  PROMOTION_CREATE_CHILD: 'App\\Models\\Promotion.create_child',
  PROMOTION_DELETE: 'App\\Models\\Promotion.delete',
  DISCOUNT_VIEW: 'App\\Models\\Discount.view',
  DISCOUNT_UPDATE: 'App\\Models\\Discount.update',
  DISCOUNT_CREATE: 'App\\Models\\Discount.create_child',
  DISCOUNT_DELETE: 'App\\Models\\Discount.delete',
  EMPLOYEES_SECTION: 'employees-section',
  CUSTOMERS_SECTION: 'customers-section',
  SERVICES_SECTION: 'services-section',
  GOODS_SECTION: 'goods-section',
  UNITS_SECTION: 'units-section',
  FINANCES_SECTION: 'finances-section',
  ANALYTICS_SECTION: 'analytics-section',
  SETTINGS_SECTION: 'settings-section',
  LOGS_SECTION: 'logs-section',
  WORK_POSITIONS_SECTION: 'work-positions-section',
  BOOKINGS_SECTION: 'bookings-section',
  FEEDBACKS_SECTION: 'App\\Models\\OrderReview.view',
  FEEDBACKS_LIST: 'App\\Models\\OrderReview.view',
  APP_REVIEW_LIST: 'App\\Models\\StoreReview.view',
  FEEDBACKS_EDIT_VOTE_OTHER: 'App\\Models\\Review.edit-vote-other',
  FEEDBACKS_CLIENT_VIEW: 'App\\Models\\Review.client:view',
  FEEDBACKS_EDIT_EMPLOYER: 'App\\Models\\Review.edit-employer',
  FINANCIAL_SERVICES: 'financial-services',
  FINANCIAL_OPERATIONS: 'financial-operations',
  IMPERSONATE: 'App\\Models\\Employer.impersonate',
  BANNERS: 'App\\Models\\Banner.view',
  NAIL_DESIGNS: 'App\\Models\\NailDesign.view',
  NEWS: 'App\\Models\\News.view',
  DEDUCTION: {
    view: 'App\\Models\\Deduction.view',
    edit: 'App\\Models\\Deduction.edit',
    create: 'App\\Models\\Deduction.create',
    recalculate: 'App\\Models\\Deduction.recalculate',
    update: 'App\\Models\\Deduction.update',
  },
  TICKETS: {
    create: 'App\\Models\\Ticket.create_child',
    view: 'App\\Models\\Ticket.view',
    update: 'App\\Models\\Ticket.update',
    delete: 'App\\Models\\Ticket.delete',
  },
  CALL_CENTER_WORKPLACE: {
    create: 'App\\Models\\CallCenterWorkplace.create',
    call: 'App\\Models\\CallCenterWorkplace.call',
    history: 'App\\Models\\CallCenterWorkplace.call-history',
    view: 'App\\Models\\CallCenterWorkplace.view',
    update: 'App\\Models\\CallCenterWorkplace.update',
    delete: 'App\\Models\\CallCenterWorkplace.delete',
    workplaceLink: 'App\\Models\\CallCenterWorkplace.workplace-link',
  },
  EMPLOYERS: {
    access_section: 'App\\Models\\Employer.access_section',
  },
  DASHBOARD: 'DASHBOARD_PERMISSIONS.dashboard',
  ANALYTICS_TABLETS: 'App\\Models\\AnalyticsReports.tablets',
  WORKPLACES: {
    create: 'App\\Models\\Workplace.create_child',
    view: 'App\\Models\\Workplace.view',
    update: 'App\\Models\\Workplace.update',
    delete: 'App\\Models\\Workplace.delete',
  },
  REVENUE_PLANS: {
    create: 'App\\Models\\UnitRevenuePlan.create_child',
    view: 'App\\Models\\UnitRevenuePlan.view',
    update: 'App\\Models\\UnitRevenuePlan.update',
    delete: 'App\\Models\\UnitRevenuePlan.delete',
  },
  CLAIM: {
    create: 'App\\Models\\Claim.create_child',
    view: 'App\\Models\\Claim.view',
    update: 'App\\Models\\Claim.update',
    delete: 'App\\Models\\Claim.delete',
  },
  SEGMENT: {
    create: 'App\\Models\\Segment.create',
    view: 'App\\Models\\Segment.view',
    update: 'App\\Models\\Segment.update',
    delete: 'App\\Models\\Segment.delete',
  },
  SURVEY: {
    view: 'SURVEY.view',
    action: 'SURVEY.action',
  },
  BONUSES: {
    view: 'BONUSES.bonuses_history',
    add: 'BONUSES.bonuses_add',
  },
  NOTIFY: 'NOTIFY_PERMISSIONS.view',
  AUTOSCHEDULE: 'autoschedule',
  USER_DOWNLOAD: {
    all: 'App\\Models\\User.download',
    withPhone: 'App\\Models\\User.download_with_phone_number',
  },
  DASHBOARD_PERMISSIONS: {
    payment_amount: 'DASHBOARD_PERMISSIONS.payment_amount',
    booking_density: 'DASHBOARD_PERMISSIONS.booking_density',
    cancelled_bookings: 'DASHBOARD_PERMISSIONS.cancelled_bookings',
    booking_sources: 'DASHBOARD_PERMISSIONS.booking_sources',
    average_check: 'DASHBOARD_PERMISSIONS.average_check',
    service_rating: 'DASHBOARD_PERMISSIONS.service_rating',
    client_notifications: 'DASHBOARD_PERMISSIONS.client_notifications',
    app_bookings: 'DASHBOARD_PERMISSIONS.app_bookings',
    app_orders: 'DASHBOARD_PERMISSIONS.app_orders',
    app_reviews: 'DASHBOARD_PERMISSIONS.app_reviews',
    yam_number_installs: 'DASHBOARD_PERMISSIONS.yam_number_installs',
    yam_new_installs: 'DASHBOARD_PERMISSIONS.yam_new_installs',
  },

  CLUB_CARD_TYPES: {
    view: 'App\\Models\\ClubCardType.view',
    create: 'App\\Models\\ClubCardType.create',
    delete: 'App\\Models\\ClubCardType.delete',
    update: 'App\\Models\\ClubCardType.update',
  },

  CLUB_CARDS: {
    view: 'App\\Models\\ClubCard.view',
    create: 'App\\Models\\ClubCard.create',
    delete: 'App\\Models\\ClubCard.delete',
    update: 'App\\Models\\ClubCard.update',
    paymentForceConfirm: 'App\\Models\\ClubCard.payment-force-confirm',
    activate: 'App\\Models\\ClubCard.activate',
    changeActivationDate: 'App\\Models\\ClubCard.update-from-date',
  },

  CALL_HISTORY: {
    callHistory: 'App\\Models\\CallCenterWorkplace.call-history',
  },

  CERTIFICATE_LOGS: {
    view: 'App\\Models\\CertificateGiveLog.view',
    create: 'App\\Models\\CertificateGiveLog.create',
  },

  PAYMENTS: {
    forceCreateClubCardPayment: 'App\\Models\\Payment.club-card-payment-force-create',
    updateSum: 'App\\Models\\Payment.update-sum',
    delete: 'App\\Models\\Payment.delete',
  },

  QR_GENERATE: {
    generalQR: 'App\\Models\\Checkin\\CheckinLog.generalQR',
  },

  VOUCHERS: {
    view: 'App\\Models\\Voucher.view',
    create: 'App\\Models\\Voucher.create',
    delete: 'App\\Models\\Voucher.delete',
  },
  VOUCHER: {
    view: 'App\\Models\\Voucher.view',
    create: 'App\\Models\\Voucher.create',
    delete: 'App\\Models\\Voucher.delete',
  },
}
const DENIED_CONSTANTS = {
  EMPLOYEE_ONLY_INFO_SERVICES_HISTORY_SHEDULE: 'App\\Models\\Employer.employee-tabs-info-ser-his-sh',
  FEEDBACKS_DISABLE_EDIT: 'feedback-disable-edit',
  RKO_ONLY_DS_OPERATION: 'App\\Models\\CashOrder.rko.only_ds',
  EMPLOYER_INFO_MAIN_INFO_CONTACTS_BLOCK: 'App\\Models\\Employer.employer-info-contacts-block',
}

const WORK_POSITIONS = {
  SUPER_ADMIN: 13,
  ADMIN: 2,
  ADMIN_TOP: 27,
  MASTER: 1,
  OFFICE: 3,
  HR: 12,
  CHIEF_HR: 10,
  MANAGER: 15,
  DISTRICT_MANAGER: 16,
  CALL_CENTER_MANAGER: 17,
  CALL_CENTER_EMPLOYEE: 18,
  CALL_CENTER_ALTERNATE_MANAGER: 25,
  CALL_CENTER_TOP_EMPLOYEE: 23,
  ACCOUNTANT: 19,
  CHIEF_ACCOUNTANT: 20,
  MASTER_TOP: 14,
  MANAGER_CLIENTS: 24,
  QUALITY_CONTROL: 26,
}

const WORK_POSITION_TYPES = {
  MASTER: 'master',
  ADMINISTRATOR: 'administrator',
  HR: 'manager_hr',
  SUPERUSER: 'superuser',
  TOP_MASTER: 'top_master',
  MANAGER: 'manager',
  LOCAL_MANAGER: 'local_manager',
  MANAGER_CALL_CENTER: 'manager_call_center',
  CALL_CENTER: 'call_center',
  ACCOUNTANT: 'accountant',
  TOP_ACCOUNTANT: 'top_accountant',
  MANAGER_MARKETING_DEPARTMENT: 'manager_marketing_department',
  TOP_OPERATOR_CALL_CENTER: 'top_operator_call_center',
  CLIENT_MANAGER: 'client_manager',
  DEPUTY_MANAGER_CALL_CENTER: 'deputy_manager_call_center',
  QUALITY_CONTROL: 'quality_control',
  TOP_ADMINISTRATOR: 'top_administrator',
  SECURITY_SERVICE: 'security_service',
  PARTNER: 'partner',
  SERVICE_TRAINER: 'service_trainer',
  PUPIL_MASTER: 'pupil_master',
}

const EMPLOYER_PHOTOS_TYPES = {
  PHOTO: 'photo',
  BEST: 'best',
  ALL: 'all',
}

const statusColors = {
  active: '#00DD00',
  busy: 'rgb(255, 179, 9)',
}

const NOTIFY_TYPES = {
  SMS: 'sms',
  PUSH: 'push',
  CRM_NOTIFICATIONS: 'crm',
  PUSH_OR_SMS: 'push_or_sms',
}

const NOTIFY_TYPES_TITLES = {
  [NOTIFY_TYPES.SMS]: 'SMS',
  [NOTIFY_TYPES.PUSH]: 'PUSH-уведомление',
  [NOTIFY_TYPES.CRM_NOTIFICATIONS]: 'CRM-уведомление',
  [NOTIFY_TYPES.PUSH_OR_SMS]: 'PUSH-уведомление или SMS',
}

Vue.config.modules = {
  crm: {
    workPositionMasterId: 1,
    workPositionTopMasterId: 14,
    availableWorkPositions: [1, 14, 32, 34, 36, 38],
    employerSearchTypes: {
      UNBLOCKED_MASTERS_AND_TOP_MASTERS: 'UNBLOCKED_MASTERS_AND_TOP_MASTERS',
    },
    storage: '/storage/',
    staticData: {
      unitLocationType: 'App\\Models\\City',
      unitTypeUnit: 0,
      bookingStatuses: {
        // BEGIN Витя, что это за хуйня ?
        Оформлена: {
          class: 'layout-item-service_new',
        },
        Подтверждена: {
          class: 'layout-item-service_confirm',
        },
        Выполнена: {
          class: 'layout-item-service_complete',
        },
        Выполняется: {
          class: 'layout-item-service_execute',
        },
        Отменена: {
          class: 'layout-item-service_cancel',
        },
        // END Витя, что это за хуйня ?
      },
      metroLinesColors: [
        { city_id: 1, name: 'red', color: '#FF0000' },
        { city_id: 1, name: 'blue', color: '#0000FF' },
        { city_id: 1, name: 'green', color: '#008000' },
        { city_id: 1, name: 'yellow', color: '#FFA500' },
        { city_id: 1, name: 'violet', color: '#7F00FF' },
        { city_id: 2, name: 'red', color: '#FF0000' },
        { city_id: 2, name: 'brown', color: '#A52A2A' },
        { city_id: 2, name: 'green', color: '#008000' },
        { city_id: 2, name: 'cian', color: '#00FFFF' },
        { city_id: 2, name: 'darkblu', color: '#00008B' },
        { city_id: 2, name: 'blue', color: '#0000FF' },
        { city_id: 2, name: 'yellow', color: '#FFFFFF' },
        { city_id: 2, name: 'violet', color: '#7F00FF' },
        { city_id: 2, name: 'orange', color: '#FFA500' },
        { city_id: 2, name: 'gray', color: '#808080' },
        { city_id: 2, name: 'lime', color: '#00FF00' },
        { city_id: 2, name: 'lightbl', color: '#ADD8E6' },
        { city_id: 2, name: 'monorai', color: '#77A1B5' },
        { city_id: 2, name: 'lightpi', color: '#FFCCCB' },
        { city_id: 2, name: 'cian', color: '#00FFFF' },
      ],
      employerActivityStatuses: [
        { name: 'Активен', value: 1, color: statusColors.active },
        { name: 'Вызов к руководству', value: 2, color: statusColors.busy },
        { name: 'Перерыв', value: 3, color: statusColors.busy },
        { name: 'Нерабочее время', value: 4, color: statusColors.busy },
      ],
      companiesTypeBlocking: [
        { title: 'Перманентно', id: 0 },
        { title: 'В определенное время', id: 1 },
        { title: 'В течение фиксированного времени после получения блокирующей оценки', id: 2 },
      ],
      employerActivityStatusesModal: [
        { name: 'Активен', value: 1, color: statusColors.active },
        { name: 'Отошел', value: 2, color: statusColors.busy },
      ],
    },
    api: {
      source: {
        all: '/api/crm/store-reviews/sources',
      },
      os: {
        all: '/api/crm/store-reviews/os',
      },
      appReviews: {
        all: '/api/crm/store-reviews',
      },
      preferences: {
        varnishes: {
          all: 'api/crm/good-give-log',
          one: '/api/crm/good-give-log/$1',
        },
      },
      serviceTemplates: {
        all: '/api/crm/service-template',
        one: '/api/crm/service-template/$1',
        copy: '/api/crm/service-template/copy',
      },
      stat: {
        services: 'api/crm/stat/services',
      },
      autoschedule: {
        statistics: {
          getGraph: 'stat',
        },
      },
      login: 'api/crm/auth/login',
      iam: 'api/crm/auth/iam',
      authentication: {
        getMastersUnits: 'api/crm/windows/units',
      },
      refresh: 'api/crm/auth/refresh',
      cashRegister: {
        all: 'api/crm/cash-register',
        one: 'api/crm/cash-register/$1',
      },
      push: {
        planningSchedules: 'api/crm/unit/$unit/planningSchedules',
      },
      bankAccount: {
        all: 'api/crm/bank-account',
        one: 'api/crm/bank-account/$1',
      },
      contractor: {
        all: 'api/crm/contractor',
        one: 'api/crm/contractor/$1',
      },
      settingsCompanies: {
        all: 'api/crm/companies',
        one: 'api/crm/companies/$1',
      },
      users: {
        all: 'api/crm/user',
        searchByPhone: 'api/crm/user/search/phone',
        search: 'api/crm/user/search',
      },
      employers: {
        all: 'api/crm/employers',
        search: 'api/crm/employers/search',
        one: 'api/crm/employers/$1',
        permission: 'api/crm/employers/$1/permission',
        form: 'api/crm/employers/form',
        statuses: 'api/crm/employers/statuses',
        states: 'api/crm/employers/states',
        services: 'api/crm/employers/$employer_id/services',
        brands: 'api/crm/visits/brands',
        employerSchedule: 'api/crm/employers/$employer_id/schedule',
        schedule: 'api/crm/employers/schedule',
        scheduleDownload: 'api/crm/employers/schedule/download',
        category: 'api/crm/employers/category',
        priceCategory: 'api/crm/employers/price-category',
        categorySync: 'api/crm/employers/category/sync',
        priceCategorySync: 'api/crm/employers/price-category/sync',
        windows: 'api/crm/employers/$employer_id/window',
        window: 'api/crm/employers/$employer_id/window/$window_id',
        invalidateSessions: 'api/crm/employers/$1/invalidate-session',
        document: 'api/crm/employers/document',
        documentType: 'api/crm/employers/document/type',
        impersonate: 'api/crm/employers/$1/impersonate',
        imagesWork: 'api/crm/employers/images',
        profile: {
          update: 'api/crm/employers/profile',
          checkToken: 'api/crm/employers/profile/check-token',
          changePassword: 'api/crm/employers/profile/change-password',
        },
        download: 'api/crm/employers/download',
        images: {
          all: 'api/crm/employers/$1/images',
          bestImageCreate: 'api/crm/employers/$1/add-best-image',
          bestImageDestroy: 'api/crm/employers/$1/delete-best-image',
        },
        absenceDays: {
          all: 'api/crm/employers/$employer_id/absence_work',
          add: 'api/crm/employers/$employer_id/absence_work',
          delete: 'api/crm/employers/$employer_id/absence_work/$item_id',
        },
        pupils: {
          contracts: {
            all: 'api/crm/employers/$employer_id/models-contracts',
            add: 'api/crm/employers/$employer_id/add-models-contract',
            delete: 'api/crm/employers/$image_id/delete-models-contract',
          },
          portfolio: 'api/crm/employers/$employer_id/add-pupil-portfolio',
        },
      },
      employerPermission: {
        permission: '/api/crm/employers/$employer_id/permission',
        fullPermission: '/api/crm/employers/$employer_id/permission?full=1',
        delete: '/api/crm/employers/$employer_id/permission',
      },
      employer_settings: {
        get: 'api/crm/employers/$employer_id/settings',
        post: 'api/crm/employers/$employer_id/settings',
      },
      feedbacks: {
        all: 'api/crm/review',
        one: 'api/crm/review/$id',
        orders: 'api/crm/order',
        newMasters: '/api/crm/feedbacks/new_masters',
      },
      claims: {
        all: 'api/crm/claims',
        claim: 'api/crm/claims',
        update: 'api/crm/claims/$id',
        alteration: 'api/crm/user/claims',
        getOrders: 'api/crm/user/claims/orders',
        delete: 'api/crm/claims/$id',
        categories: 'api/crm/user/claims/categories',
        claimCategories: 'api/crm/claims/categories',
      },
      userClaim: {
        getAll: 'api/crm/user/claims',
        getById: 'api/crm/user/claims/$id',
        create: 'api/crm/user/claims',
        update: 'api/crm/user/claims/$id',
        getOrders: 'api/crm/user/claims/orders',
        categoriesResolution: 'api/crm/user/claims/categories',
      },
      addresses: {
        all: 'api/crm/addresses',
        one: 'api/crm/addresses/$id',
      },
      userAddresses: {
        get: 'api/crm/user/$id/addresses',
      },
      fingerPrints: {
        post: 'api/crm/fingerprint',
        get: 'api/crm/employers/$id/fingerprint',
        delete: 'api/crm/employers/$employer_id/fingerprint/$finger_id',
        postCheckIn: 'api/crm/fingerprint/check-in',
        getCheckIn: 'api/crm/fingerprint/check-in',
        putCheckIn: 'api/crm/fingerprint/check-in/$id',
        creteCheckIn: 'api/crm/fingerprint/check-in/create',
      },
      contractors: {
        all: 'api/crm/contractor',
        one: 'api/crm/contractor/$1',
      },
      order: {
        status: '/api/crm/order/statuses',
      },
      payment: {
        status: '/api/crm/payments/statuses',
        type: '/api/crm/payments/types',
        refresh: '/api/crm/payments/check_status',
      },
      publicOrders: {
        all: 'api/orders',
        one: 'api/orders/$hash',
      },
      subfeedbacks: {
        all: 'api/crm/order_subreviews',
        one: 'api/crm/order_subreviews/$id',
        images: 'api/crm/order_subreviews/$id/images',
      },
      feedbackStatuses: {
        all: 'api/crm/order_review_statuses',
      },
      reviews: {
        all: 'api/reviews',
        one: 'api/review/$hash',
        onePost: 'api/review',
        info: 'api/review/info/$hash',
      },
      subreviews: {
        all: 'api/order_subreviews',
        one: 'api/order_subreviews/$id',
      },
      sales: {
        all: 'api/crm/discounts',
        one: 'api/crm/discounts/$id',
      },
      itemReviews: {
        all: 'api/order_item_reviews',
        one: 'api/order_item_reviews/$id',
      },
      customers: {
        all: 'api/crm/customers',
        one: 'api/crm/customers/$1',
        visitStat: 'api/crm/customers/$1/stat/visit',
      },
      huntingResources: {
        all: 'api/crm/hunting-resources',
      },
      workplaces: {
        one: 'api/crm/unit/$1/workplaces/$2',
        all: 'api/crm/unit/workplaces',
        services: 'api/crm/unit/$unit_id/workplace/$workplace_id/services',
      },
      unit_workplaces: {
        all: 'api/crm/unit/$1/workplace',
        newAll: 'api/crm/unit/$1/workplace_new',
        one: 'api/crm/unit/$unitId/workplace_new/$workplaceId',
      },
      bookings: {
        one: 'api/crm/bookings/$1',
        all: 'api/crm/bookings',
        counter: 'api/crm/bookings/counter',
        sum: 'api/crm/bookings/sum',
        statuses: 'api/crm/bookings/statuses',
        updateWindow: 'api/crm/window/updateByBooking',
        statusesHistory: 'api/crm/booking/$1/statuses',
        bookingDownload: 'api/crm/bookings/download',
        updateVisitInfo: 'api/crm/visits/update/$1',
        attachPhotos: 'api/crm/visits/photos',
      },
      bookingSources: {
        one: 'api/crm/booking_sources/$1',
        all: 'api/crm/booking_sources',
      },
      permissions: {
        all: 'api/crm/permission',
        groupByModel: 'api/crm/permission/groups/model',
      },
      services: {
        all: 'api/crm/service',
        one: 'api/crm/service/$1',
        form: 'api/crm/service/form',
        price: 'api/crm/service/$service_id/price',
        priceDestroy: 'api/crm/service/$service_id/price/$price_id',
        prices: 'api/crm/service/prices',
        allWithCompany: '/api/crm/companies/$company/services',
      },
      serviceCategories: {
        all: 'api/crm/service/category',
        one: 'api/crm/service/category/$1',
        allWithWorkplaces: 'api/crm/service/category/withWorkplaces/$1',
        servicesCompany: 'api/crm/companies/$1/services',
        categoriesWithServices: 'api/crm/companies/$1/categories_with_services',
        allNewWithCompany: '/api/crm/companies/$company/categories',
      },
      goods: {
        all: 'api/crm/good',
        one: 'api/crm/good/$1',
        sold: 'api/crm/good/sold',
      },
      goodBrands: {
        all: 'api/crm/good_brand',
        one: 'api/crm/good_brand/$1',
      },
      goodLines: {
        all: 'api/crm/good-lines',
        one: 'api/crm/good-lines/$1',
      },
      goodTypes: {
        all: 'api/crm/good_type',
        one: 'api/crm/good_type/$1',
      },
      goodGroups: {
        all: 'api/crm/good-group',
        one: 'api/crm/good-group/$1',
      },
      goodFlows: {
        all: 'api/crm/good-flow',
        one: 'api/crm/good-flow/$1',
        type: 'api/crm/good-flow/type',
        status: 'api/crm/good-flow/status',
        goods: 'api/crm/good-flow/goods',
        qty: 'api/crm/good-flow/qty',
        barcode: 'api/crm/good-flow/barcode/$1',
      },
      goodFlowItems: {
        all: 'api/crm/good-flow/goods',
        one: 'api/crm/good-flow/goods/$1',
      },
      goodRemains: {
        all: 'api/crm/good-remain',
        one: 'api/crm/good-remain/$1',
        history: 'api/crm/good-remain/$1/history',
        download: 'api/crm/good-remain/download',
      },
      goodGives: {
        all: 'api/crm/good-give',
        one: 'api/crm/good-give/$1',
        check: 'api/crm/good-give/check/$1',
        available: 'api/crm/good-give/available',
        process: 'api/crm/good-give/process',
        weight: 'weight',
      },
      goodInvoices: {
        all: 'api/crm/good-invoice',
        one: 'api/crm/good-invoice/$1',
        process: 'api/crm/good-invoice/$1/process',
        status: 'api/crm/good-invoice/status',
        item: 'api/crm/good-invoice/item/$1',
      },
      goodInvents: {
        all: 'api/crm/good-invent',
        one: 'api/crm/good-invent/$1',
        add: 'api/crm/good-invent/$1/add',
        process: 'api/crm/good-invent/$1/process',
        recount: 'api/crm/good-invent/$1/recount',
        status: 'api/crm/good-invent/status',
      },
      goodInventItems: {
        all: 'api/crm/good-invent/item',
        one: 'api/crm/good-invent/item/$1',
        barcode: 'api/crm/good-invent/barcode/$1',
      },
      goodOrders: {
        all: 'api/crm/good-order',
        one: 'api/crm/good-order/$1',
        status: 'api/crm/good-order/status',
        refresh: 'api/crm/good-order/$1/refresh',
        process: 'api/crm/good-order/$1/process',
        withdraws: 'api/crm/good-order/withdraws',
      },
      goodOrderItems: {
        all: 'api/crm/good-order-item',
        one: 'api/crm/good-order-item/$1',
        items: 'api/crm/good-order/$1/items',
      },
      goodOrderProducts: {
        all: 'api/crm/good-order-product',
        one: 'api/crm/good-order-product/$1',
        refresh: 'api/crm/good-order-product/refresh',
      },
      equipmentPlaces: {
        all: 'api/crm/equipment/places',
      },
      equipmentTypes: {
        all: 'api/crm/equipment/types',
        one: 'api/crm/equipment/types/$1',
      },
      audits: {
        all: 'api/crm/audits',
      },
      workPositions: {
        one: 'api/crm/work_positions/$1',
        all: 'api/crm/work_positions',
        types: 'api/crm/work_positions/types',
      },
      regions: {
        all: 'api/crm/region',
        one: 'api/crm/region/$1',
      },
      countries: {
        all: 'api/crm/country',
        one: 'api/crm/country/$id',
      },
      cities: {
        all: 'api/crm/city',
        one: 'api/crm/city/$1',
      },
      nailDesigns: {
        tags: {
          all: 'api/crm/nail-design-tags',
        },
        all: 'api/crm/nail-designs',
        one: 'api/crm/nail-designs/$1',
      },
      metros: {
        all: 'api/crm/metro',
      },
      district: {
        all: 'api/crm/district',
      },
      candidates: {
        all: 'api/crm/vkstream/event',
        one: 'api/crm/vkstream/getUserInfo/$1',
      },
      kkmNotifications: {
        sessionOpen: 'api/crm/kkm/notification/session-open',
        sessionClosed: 'api/crm/kkm/notification/session-close',
      },
      kkmCashier: {
        sessionOpen: '/api/crm/kkm/cashier/session-open',
        sessionClosed: '/api/crm/kkm/cashier/session-close',
      },
      vkstream: {
        all: 'api/crm/vkstream/rule',
        one: 'api/crm/vkstream/rule/$1',
      },
      schedules: {
        all: 'api/crm/unit/$1/schedules',
        store: 'api/crm/employers/$1/schedule',
        delete: 'api/crm/employers/$1/schedule',
        approve: 'api/crm/employers/schedule-approve',
      },
      chat: {
        get: 'api/crm/chat',
        store: 'api/crm/chat',
        getChatList: 'api/crm/chat/getChatList',
        create: 'api/crm/chat/create',
        addEmployers: 'api/crm/chat/addEmployers',
        searchEmployee: 'api/crm/chat/searchEmployee',
      },
      workPlaces: {
        all: 'api/crm/unit/$unit_id/workplace',
        one: 'api/crm/unit/$unit_id/workplace/$workplace_id',
        available: 'api/crm/unit/$unit_id/workplace/available',
        services: 'api/crm/unit/$unit_id/workplace/$workplace_id/services',
      },
      analytics: {
        all: 'api/crm/analytics',
        one: 'api/crm/analytics/$1',
        data: 'api/crm/analytics/data',
        view: 'api/crm/analytics/view',
        detail: 'api/crm/analytics/detail/$1',
        filter: 'api/crm/analytics/filter/$1',
        export: 'api/crm/analytics/export',
        tablets: 'api/crm/stat/service_time',
        fillStudios: 'api/crm/analytics/fill-studios',
      },
      sipHistory: {
        all: 'api/crm/sip-history',
        one: 'api/crm/sip-history/$1',
        start: 'api/crm/sip-history/start',
        finish: 'api/crm/sip-history/finish',
      },
      sipHistoryComment: {
        all: 'api/crm/sip-history-comment',
        one: 'api/crm/sip-history-comment/$1',
      },
      sipParams: {
        all: 'api/crm/sip-params',
        one: 'api/crm/sip-params/$1',
        active: 'api/crm/sip-params/active',
      },
      units: {
        allStatic: '/api/crm/unit/public',
        all: 'api/crm/unit',
        one: 'api/crm/unit/$unit_id',
        windows: 'api/crm/unit/$unit_id/windows',
        windowsDownload: 'api/crm/unit/$unit_id/windows/download',
        schedules: 'api/crm/unit/$unit_id/schedules',
        types: 'api/crm/unit/types',
        prepay: 'api/crm/unit/$unit_id/prepay',
        deletePrepay: 'api/crm/unit/$unit_id/prepay/$prepay_id',
        images: 'api/crm/unit/$unit_id/images',
        unitsByCompany: '/api/crm/unit',
      },
      unitRevenue: {
        manicure: {
          all: 'api/crm/unit-kpi/manicure/',
          one: 'api/crm/unit-kpi/manicure/$id',
          create: '/api/crm/unit-kpi/manicure/per_month_by_day',
        },
        pedicure: {
          all: 'api/crm/unit-kpi/pedicure/',
          one: 'api/crm/unit-kpi/pedicure/$id',
          create: '/api/crm/unit-kpi/pedicure/per_month_by_day',
        },
        common: {
          all: 'api/crm/unit-kpi/union/',
        },
        default: {
          all: 'api/crm/unit-revenue-plan',
          one: 'api/crm/unit-revenue-plan/$id',
          create: 'api/crm/unit-revenue-plan',
        },
      },
      companies: {
        all: 'api/crm/companies',
        one: 'api/crm/companies/$company_id',
        create: 'api/crm/companies',
        update: 'api/crm/companies/$company_id',
        delete: 'api/crm/companies/$company_id',
        copy: 'api/crm/companies/copy',
        imageAdd: 'api/crm/companies/$company_id/images',
        imageUpdate: 'api/crm/companies/$company_id/images/$image_id',
        imageDelete: 'api/crm/companies/$company_id/images/$image_id',
        importUserFields: '/api/crm/user/import_fields',
        importUsers: '/api/crm/companies/$company_id/import/users',
        types: '/api/crm/company/types',
      },
      userSources: {
        all: 'api/crm/user/sources',
      },
      stores: {
        all: 'api/crm/store',
      },
      checkin: {
        getQrOrSms: 'api/crm/checkin',
        getStatus: 'api/crm/checkin/qr/status/$id',
        employersStatuses: 'api/crm/checkin',
        authBySms: 'api/crm/checkin/sms',
      },
      windows: {
        all: 'api/crm/unit/$unit_id/workplace/$workplace_id/window',
        one: 'api/crm/unit/$unit_id/workplace/$workplace_id/window/$window_id',
        search: 'api/crm/window',
        create: 'api/crm/window',
        update: 'api/crm/window/$id',
        merge: 'api/crm/window/merge',
        searchNew: 'api/crm/window_new',
      },
      KKM: {
        xReport: 'cashier/x-report',
        zReport: 'cashier/z-report',
        check: 'cashier/check',
        printQR: 'cashier/QR',
        files: 'files',
        refund: 'cashier/refund',
        test: 'cashier/test',
        sessionOpen: 'cashier/session-open',
        reportX: 'cashier/x-report',
        sessionClose: 'cashier/session-close',
        safePackage: 'api/crm/safe-package',
        sendReceipt: '/api/crm/kkm/cashier/receipt',
        openShift: '/api/crm/kkm/cashier/shifts',
        closeShift: '/api/crm/kkm/cashier/shifts/close',
      },
      finances: {
        paymentRequests: {
          all: 'api/crm/payment-requests',
          one: 'api/crm/payment-requests/$id',
        },
        all: 'api/crm/cash-order',
        one: 'api/crm/cash-order/$order_id',
        orders: 'api/crm/order',
        ordersDownload: 'api/crm/order/download',
        salaries: 'api/crm/salary',
        order: 'api/crm/order/$order_id',
        orderWallet: 'api/crm/order/$id/wallet',
        forceCloseOrder: 'api/crm/order/done-force',
        forcePrintCheck: 'api/crm/order/$order_id/check-printed',
        discount: 'api/crm/order/$order_id/discount',
        salary: 'api/crm/salary/$1',
        salaryItem: 'api/crm/salary/$1/item',
        salaryCalculate: 'api/crm/salary/calculate',
        basis: 'api/crm/cash-order/basis',
        operation: 'api/crm/cash-order/operation',
        certificateAll: 'api/crm/certificate',
        certificatesInvent: 'api/crm/certificates/inventory',
        certificateOne: 'api/crm/certificate',
        certificates: 'api/crm/certificates',
        certificatesTransfer: 'api/crm/certificates/transfer',
        transferDocuments: 'api/crm/documents/',
        certificatesOne: 'api/crm/certificates/$id',
        certificatesCompare: 'api/crm/certificates/compare-sale-redeem',
        certificate: 'api/crm/certificate',
        exchange: 'api/crm/exchange_sum',
        transactionsAll: 'api/crm/employers/transactions',
        transactionsOne: 'api/crm/employers/transactions/$id',
        documentDownload: 'api/crm/documents/$1/download',
        cancelPrintCheck: 'api/crm/order/$id/revert-check-printed',
        salaryDetail: 'api/crm/salary/$1/detail/$2',
        salaryDescription: '/api/crm/salary/description',
        certificatesNominations: '/api/crm/certificates/nominations',
      },
      smsHistory: {
        all: 'api/crm/sms-log',
        statuses: 'api/crm/sms-log/statuses',
        receiverLogs: 'log/receiver',
      },
      notifications: {
        all: 'api/crm/notifications',
        unread: 'api/crm/notifications/unread',
        read: 'api/crm/notifications/read',
        one: 'api/crm/notifications/$1',
      },
      news: {
        all: 'api/crm/employers/news',
        totalnews: 'api/crm/employers/news/notifications',
        one: 'api/crm/notifications/news/$id',
        top: 'api/crm/notifications/news/top',
        put: 'api/crm/notifications/news/fix-top',
        sticky: 'api/crm/notifications/sticky',
        fixSticky: 'api/crm/employers/news/notifications',
        delete: 'api/crm/employers/news/$id/notification',
      },
      notify: {
        template: 'template',
        templateFilters: 'template/filters',
        templateOne: 'template/$id',
        templateContent: 'template/$id/content',
        templateSend: 'template/$id/send',
        markers: 'markers',
        log: 'log',
        logFilters: 'log/filters',
      },
      promotions: {
        all: 'api/crm/promotions',
        one: 'api/crm/promotions/$id',
        actual: 'api/crm/promotions/actual',
      },
      testPush: {
        all: 'api/crm/test/$request/$type',
      },
      tinymce: {
        upload: 'api/crm/tinymce/upload',
      },
      notifyPopupEmployer: {
        all: 'api/crm/notify-popup-employer',
      },
      vouchers: {
        all: 'api/v1/promo-codes',
        one: 'api/v1/promo-codes/$id',
        order: 'api/v1/promo-codes/$id',
      },
    },
    route: {
      index: '/',
      auth: '/auth',
      analytics: {
        one: '/analytics/$1',
        all: '/analytics',
      },
      serviceTemplates: {
        one: '/service_templates/$1',
        all: '/service_templates',
      },
      employers: {
        one: '/employers/$1',
        all: '/employers',
        new: '/employers/new',
      },
      feedbacks: {
        one: '/feedbacks/$id',
        all: '/feedbacks',
      },
      settings: {
        company: '/settings/company/$1',
        system: '/settings/system/$1',
        account: '/settings/account',
      },
      contractors: {
        all: '/contractors',
        one: '/contractors/$1',
        new: '/contractors/new',
      },
      customers: {
        all: '/customers',
        one: '/customers/$1',
        new: '/customers/new',
      },
      workplaces: {
        one: '/unit/$1/workplaces/$2',
        all: '/unit/workplaces',
      },
      bookings: {
        one: '/bookings/$1',
        all: '/bookings',
        new: '/bookings/new',
        statuses: '/bookings/statuses',
      },
      services: {
        one: '/services/$1',
        all: '/services',
        new: '/services/new',
      },
      goods: {
        one: '/goods/$good_id',
        all: '/goods',
        new: '/goods/new',
      },
      goodFlows: {
        one: '/good-flows/$1',
        all: '/good-flows',
      },
      goodRemains: {
        all: '/good-remains',
        one: '/good-remains/$1',
      },
      goodGives: {
        one: '/good-gives/$1',
        all: '/good-gives',
      },
      goodInvoices: {
        one: '/good-invoices/$1',
        all: '/good-invoices',
      },
      goodInvents: {
        one: '/good-invents/$1',
        all: '/good-invents',
      },
      goodOrders: {
        all: '/good-orders',
        one: '/good-orders/$1',
        new: '/good-orders/new',
      },
      goodOrderItems: {
        all: '/good-order-item',
        one: '/good-order-item/$1',
      },
      goodsStandard: {
        all: '/goods-standard',
      },
      goodGroups: {
        all: '/good_groups',
        one: '/good_groups/$1',
        new: '/good_groups/new',
      },
      equipmentTypes: {
        all: '/equipment-types',
        one: '/equipment-types/$1',
        new: '/equipment-types/new',
      },
      workPositions: {
        one: '/work_positions/$1',
        all: '/work_positions',
      },
      serviceCategory: {
        one: '/services/category/$1',
        all: '/services/category',
      },
      serviceCategories: {
        all: '/services/category',
        one: '/services/category/$1',
      },
      units: {
        all: '/units',
        one: '/units/$unit_id',
        new: '/units/new',
      },
      unitRevenuePlans: {
        all: '/revenue-plan',
      },
      workPlaces: {
        all: '/unit/workplaces',
        new: '/unit/workplaces/new',
        one: '/units/$unit_id/workplaces/$workplace_id',
      },
      logs: {
        all: '/logs',
        one: '/logs/$1',
      },
      finances: {
        rko_all: '/rko',
        rko_one: '/rko/$1',
        order: {
          new: '/finance/order/new/$1',
          list: '/finance/order',
          one: '/finance/order/$1',
        },
        zp: '/finance/zp',
      },
      smsHistory: {
        all: '/sms',
      },
      tickets: {
        all: '/tickets',
        new: '/tickets/new',
        one: '/tickets/$1',
      },
      tickets_group: {
        all: '/tickets/groups',
        new: '/tickets/groups/new',
        one: '/tickets/groups/$1',
      },
      companies: {
        one: '/companies/$1',
        all: '/companies',
        new: '/companies/new',
      },
    },
    localization: {
      en: {
        menu: {
          logout: 'Logout',
        },
      },
    },
  },
  users: {
    api: {
      login: 'api/users/auth/login',
      iam: 'api/users/auth/iam',
      social: {
        vkontakte: 'api/users/auth/vkontakte',
        twitter: 'api/users/auth/twitter',
        facebook: 'api/users/auth/facebook',
      },
      socialLogin: 'api/users/auth/social_login',
    },
    route: {
      index: '/',
      auth: '/auth',
    },
    localization: {
      en: {
        menu: {
          logout: 'Logout',
        },
      },
    },
  },
}

Vue.config.countries = [
  {
    name: 'Украина',
    ISO: 'UA',
    phoneMask: '## ### ## ##',
    default: false,
    countryCodeMask: '+###',
    countryCode: '+380',
    id: 2,
  },
  {
    name: 'Россия',
    ISO: 'Ru',
    phoneMask: '### ### ## ##',
    default: true,
    countryCodeMask: '+#',
    countryCode: '+7',
    confirmationCodeMask: '####',
    id: 1,
  },
  {
    name: 'Узбекистан',
    ISO: 'UZB',
    phoneMask: '## ### ## ##',
    default: true,
    countryCodeMask: '+###',
    countryCode: '+998',
    confirmationCodeMask: '####',
    id: 1,
  },
  {
    name: 'Республика Беларусь',
    ISO: 'BY',
    phoneMask: '## ### ## ##',
    default: true,
    countryCodeMask: '+###',
    countryCode: '+375',
    id: 3,
  },
]

// In seconds
Vue.config.duration = {
  from: 0,
  to: 36000,
  quantum: 900,
}

Vue.config.durationForWindows = {
  from: 3600,
  to: 14400,
  quantum: 900,
}

Vue.config.durationDefault = {
  from: 5400,
}

Vue.config.analyticColors = ['#36AFBB', '#E91D35', '#E9761D', '#03A5EB', '#BF0099', '#6633CC', '#33CC66']

Vue.config.analyticSettings = {
  defaultFontColor: 'gray',
  defaultFontFamily: 'Roboto, sans-serif',
  defaultFontSize: 12,
  defaultFontStyle: 'normal',
  responsive: true,
  maintainAspectRatio: false,
  elements: {
    line: {
      fill: false,
      tension: 0,
    },
  },
  legend: {
    labels: {
      boxWidth: 12,
      padding: 20,
    },
  },
}

Vue.config.format = {
  date: 'DD.MM.YYYY',
  month: 'MM.YYYY',
  prettyMonth: 'MMMM',
  prettyDateWithoutYear: 'DD.MM',
  prettyDateWithoutDay: 'MMMM YYYY',
  prettyDateFull: 'DD.MM.YYYY HH:mm:ss',
  prettyDateWithoutSeconds: 'DD.MM.YYYY HH:mm',
  serverDate: 'YYYY-MM-DD 00:00:00',
  serverEndDate: 'YYYY-MM-DD 23:59:59',
  serverDateFull: 'YYYY-MM-DD HH:mm:ss',
  datepickerDate: 'YYYY-MM-DD',
  datepickerMonth: 'YYYY-MM',
  datepickerMonthStart: 'YYYY-MM-01',
  datepickerMonthOnly: 'MM',
  time: 'HH:mm:ss',
  shortTime: 'HH:mm',
  dateString: {
    datetime: 'DD.MM.YY HH:mm',
    date: 'DD.MM.YYYY',
    time: 'HH:mm',
    day: 'D MMMM YYYY',
    week: 'MMMM YYYY, Wo',
    month: 'MMMM YYYY',
    year: 'YYYY',
  },
  dateNumber: {
    datetime: 'YYYYMMDDHHmm',
    time: 'YYYYMMDDHHmm',
    day: 'YYYYMMDD',
    week: 'YYYYWW',
    month: 'YYYYMM',
    year: 'YYYY',
  },
  numberLocale: 'ru-RU',
  integerOptions: { style: 'decimal' },
  floatOptions: { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 },
  currencyOptions: { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 },
  percentOptions: { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 },
}

Vue.config.regexp = {
  barcode: '^\\d{12,13}$',
}

Vue.config.snackbar = {
  timeout: 2000,
}

Vue.config.statuses = {
  workPositionOffice: 'Офис',
}

Vue.config.localization = {
  en: {
    name: 'Name',
    windowNoDataText: "Can't find windows using this parameters. Try with another.",
    title: 'Title',
    emailConfirmed: 'Email confirmed',
    emailDenied: 'Email denied',
    newFeedbackTitle: 'New feedback',
    feedbackTitle: 'Feedback: $id',
    serviceTitle: 'Service name',
    serviceCategoryTitle: 'Service category',
    phone: 'Phone number',
    phoneNumber: 'Phone number',
    loginLabel: 'Login',
    errorLoginText: 'Invalid login/password',
    email: 'Email',
    rememberMeLabel: 'Remember me',
    password: 'Password',
    employer: 'Employer',
    employers: 'Employers',
    feedbacks: 'Feedbacks',
    newEmployer: 'New employer',
    id: 'ID',
    studioAndEmployer: 'Studio/Employer',
    position: 'Position',
    code: 'Code',
    article: 'Article',
    codeAndArticle: 'Code/Article',
    categoryAndService: 'Category/Service',
    price: 'Price',
    nominalDuration: 'Nominal duration',
    services: 'Services',
    service: 'Service',
    goods: 'Goods',
    good: 'Good',
    newGood: 'New good',
    deleteGood: 'Delete good: $good?',
    goodGroups: 'Good groups',
    goodGroup: 'Good group',
    newGoodGroup: 'New good group',
    deleteGoodGroup: 'Delete good group: $1?',
    goodBarcodeFound: 'Barcode already in use: $1',
    goodFlow: 'Goods flow',
    deleteGoodFlow: 'Delete document: #$1?',
    goodFlowBarcodeNotFound: 'Barcode not found: $1',
    goodFlowGoodAdded: 'Good added: $1',
    goodFlowValidation: {
      goodWithdrawRemains: 'Withdraw failed, check goods remains',
    },
    goodRemains: 'Goods remains',
    goodRemain: 'Good remains',
    deleteGoodRemain: 'Delete «$1» from store: $2 ?',
    goodInvoices: 'Good invoice import',
    goodInvoiceUpload: 'Upload invoice',
    goodInvoice: 'Good invoice',
    deleteInvoice: 'Delete invoice: $item?',
    processInvoice: 'Create document for invoice $num from $dat?',
    processWarning: 'Attention, new nomenclature will be created — $num pcs.!',
    importInvoiceValidation: {
      fileFormat: 'File format error!',
      duplicateNumber: 'Document number already loaded',
    },
    goodInvents: 'Goods inventories',
    goodInvent: 'Goods inventory',
    deleteInvent: 'Delete inventory: $item?',
    processInvent: 'Create document for inventory: #$num?',
    inventItemNumber: {
      shortage: 'Shortage',
      equality: 'Equality',
      excess: 'Excess',
    },
    goodInventGoodAdded: 'Good added: $1 — $2 pcs.',
    goodInventGoodUpdated: 'Good updated: $1 — $2 pcs.',
    goodOrderValidation: {
      orderError: 'Good order error!',
      emptyOrder: 'No items ordered!',
      unitNotFound: 'External unit not found!',
      resultError: 'Request error',
    },
    goodOrders: 'Good orders',
    goodOrder: 'Good order',
    deleteOrder: 'Delete order?',
    goodsStandard: 'Goods standard',
    goodOrderRule: 'Order rule',
    equipmentType: 'Equipment type',
    equipmentTypes: 'Equipment types',
    equipmentTypeNew: 'New equipment type',
    deleteEquipmentType: 'Delete equipment type: $item?',
    newService: 'New service',
    newWorkPosition: 'New work position',
    calendarTitle: 'Calendar',
    addBooking: 'Add booking',
    calendarSearch: 'Calendar search',
    permissionTranslations: {
      'App\\Models\\Unit': 'Units',
      'App\\Models\\UnitRevenuePlan': 'Revenue plan',
      'App\\Models\\Company': 'Companies',
      'App\\Models\\Employer': 'Employers',
      'App\\Models\\Workplace': 'Work places',
      'App\\Models\\WorkPosition': 'Work positions',
      'App\\Models\\ServicePrice': 'Prices',
      'App\\Models\\EmployerSchedulesPlanning': 'Schedule planning',
      'App\\Models\\Certificate': 'Certificates',
    },
    smsEventMap: {
      phone_change: 'Change phone',
      'App\\Notifications\\EmployerResetPassword': 'Change password',
      phone_confirm: 'Phone confirm',
      booking_done: 'Booking done',
      'App\\Notifications\\BookingOrdered': 'Booking done',
    },
    callType: {
      incoming: 'Incoming',
      outcoming: 'Outcoming',
    },
    employerFilters: {
      id: {
        label: 'Employer',
        position: 0,
      },
      unit_id: {
        label: 'Unit',
        position: 1,
        getter: 'units',
      },
      work_position_id: {
        label: 'Work position',
        position: 2,
        view: Vue.config.VIEW_SELECT,
        getter: 'workPositions',
        itemText: 'title',
        itemValue: 'id',
      },
      // 'employerStatus.id': {
      //   label: 'Status',
      //   position: 3,
      //   getter: 'employerStatuses'
      // },
      'employerState.id': {
        label: 'State',
        position: 3,
        getter: 'employerStates',
      },
      'serviceCategories.id': {
        label: 'Service category',
        position: 4,
        getter: 'serviceCategories',
      },
      'services.id': {
        label: 'Services',
        position: 5,
        getter: 'services',
      },
      hr_manager_id: {
        label: 'HR manager',
        position: 6,
        getter: 'hrEmployers',
      },
      interview_at: {
        label: 'Interview date',
        position: 7,
      },
    },
    // feedbackFilters: {
    //   date: {
    //     label: 'Date',
    //     position: 1,
    //   },
    // },
    customerFilters: {
      id: {
        label: 'Customer (Name, phone)',
        position: 0,
      },
      email: {
        label: 'Email',
        position: 2,
      },
      deleted_at: {
        label: 'State',
        position: 3,
        itemsYesNo: [
          { text: 'Not deleted', value: 0 },
          { text: 'Deleted', value: 1 },
        ],
        permission: 'CUSTOMER_RESTORE',
      },
    },
    workplaceFilters: {
      'units.name': {
        label: 'Salon',
        position: 0,
      },
      'units.workplaces.serviceCategories.services.title': {
        label: 'Service',
        position: 1,
      },
      name: {
        label: 'City',
        position: 2,
      },
    },
    serviceFilters: {
      title: {
        label: 'Service',
        position: 0,
      },
    },
    serviceCategoryFilters: {
      title: {
        label: 'Category',
        position: 0,
      },
      'services.title': {
        label: 'Service',
        position: 1,
      },
    },
    logFilters: {
      id: {
        label: 'Object',
        position: 0,
      },
      model_type: {
        label: 'Object type',
        position: 1,
        getter: 'logModelTypes',
      },
      event: {
        label: 'Action',
        position: 2,
        getter: 'logEvents',
      },
      user_id: {
        label: 'User',
        position: 3,
      },
    },
    newWorkPlace: 'New work place',
    logs: 'Logs',
    action: 'Action',
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
    object: 'Object',
    user: 'User',
    time: 'Time',
    field: 'Field',
    before: 'Before',
    after: 'After',
    city: 'City',
    unitName: 'Name',
    units: 'Units',
    employerStatuses: {
      0: 'Worked',
      1: 'Hired',
      2: 'Fired',
    },
    educations: {
      0: 'Higher',
      1: 'Secondary',
      2: 'Incomplete higher',
    },
    analytics: 'Analytics',
    analyticsFilters: {
      title: {
        label: 'Title',
        position: 0,
      },
    },
    workPositions: 'Work positions',
    workPositionFilters: {
      title: {
        label: 'Work position',
        position: 0,
      },
    },
    cityFilters: {
      name: {
        label: 'City',
        position: 0,
      },
      'units.address': {
        label: 'Address',
        position: 1,
      },
      'units.name': {
        label: 'Unit name',
        position: 3,
      },
    },
    unitFilters: {
      name: {
        label: 'Name',
        position: 0,
      },
      address: {
        label: 'Address',
        position: 1,
      },
      type: {
        label: 'Type',
        position: 2,
        getter: 'unitTypesFilter',
      },
    },
    unitRevenuePlanFilters: {
      unit_id: {
        label: 'Unit',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      begin_at: {
        label: 'Date',
        position: 1,
        view: Vue.config.VIEW_DATEPICKER_MONTH,
      },
    },
    goodFilters: {
      id: {
        label: 'Title',
        position: 0,
      },
      good_group_id: {
        label: 'Group',
        position: 1,
        getter: 'groupGroups',
      },
      good_brand_id: {
        label: 'Brand',
        position: 2,
        getter: 'groupBrands',
      },
    },
    goodGroupFilters: {
      id: {
        label: 'Title',
        position: 0,
      },
      products: {
        label: 'Supplier products',
        position: 1,
        itemsYesNo: [
          { text: 'No', value: 0 },
          { text: 'Yes', value: 1 },
        ],
      },
    },
    goodFlowFilters: {
      issued_at: {
        label: 'Date',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      id: {
        label: 'Number',
        position: 1,
      },
      good_flow_type_id: {
        label: 'Type',
        position: 2,
        getter: 'flowTypes',
      },
      good_flow_status_id: {
        label: 'Status',
        position: 3,
        getter: 'flowStatuses',
      },
      flow_unit_id: {
        label: 'Unit',
        position: 4,
        getter: 'units',
        itemText: 'name',
      },
      flow_contractor_id: {
        label: 'Contractor',
        position: 5,
        getter: 'contractors',
        itemText: 'name_full',
        itemValue: 'id',
        view: Vue.config.VIEW_SELECT,
      },
      comment: {
        label: 'Comment',
        position: 6,
      },
      deleted_at: {
        label: 'State',
        position: 6,
        itemsYesNo: [
          { text: 'Not deleted', value: 0 },
          { text: 'Deleted', value: 1 },
        ],
        permission: 'RESTORE_PRODUCT_FLOW',
      },
    },
    goodRemainFilters: {
      unit_id: {
        label: 'Unit',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      'good.good_group_id': {
        label: 'Group',
        position: 1,
        getter: 'goodGroups',
      },
      'good.good_brand_id': {
        label: 'Brand',
        position: 2,
        getter: 'goodBrands',
      },
      'good.title': {
        label: 'Title',
        position: 3,
      },
      updated_at: {
        label: 'Updated',
        position: 4,
        view: Vue.config.VIEW_DATEPICKER,
      },
    },
    goodGiveFilters: {
      unit_id: {
        label: 'Unit',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      'employer.id': {
        label: 'Employer',
        position: 1,
      },
      'good.title': {
        label: 'Material',
        position: 2,
      },
      status: {
        label: 'Status',
        position: 3,
        getter: 'goodGiveStatuses',
      },
      barcode: {
        label: 'Barcode',
        position: 4,
      },
      updated_at: {
        label: 'Date',
        position: 5,
        view: Vue.config.VIEW_DATEPICKER,
      },
    },
    goodInvoiceFilters: {
      created_at: {
        label: 'Date',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      issued_at: {
        label: 'Document date',
        position: 1,
        view: Vue.config.VIEW_DATEPICKER,
      },
      number: {
        label: 'Number',
        position: 2,
      },
      status: {
        label: 'Status',
        position: 3,
        getter: 'invoiceStatuses',
      },
      unit_id: {
        label: 'Unit',
        position: 4,
        getter: 'units',
        itemText: 'name',
      },
      'employer.id': {
        label: 'Employer',
        position: 5,
      },
    },
    goodInventFilters: {
      updated_at: {
        label: 'Date',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      status: {
        label: 'Status',
        position: 3,
        getter: 'inventStatuses',
      },
      unit_id: {
        label: 'Unit',
        position: 4,
        getter: 'units',
        itemText: 'name',
      },
      store_id: {
        label: 'Store',
        position: 5,
        getter: 'getStores',
      },
      'employer.id': {
        label: 'Employer',
        position: 5,
      },
    },
    goodOrderFilters: {
      updated_at: {
        label: 'Date',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      unit_id: {
        label: 'Unit',
        position: 1,
        getter: 'units',
        itemText: 'name',
      },
      store_id: {
        label: 'Store',
        position: 2,
        getter: 'getStores',
        itemText: 'title',
      },
      employer_id: {
        label: 'Employer',
        position: 3,
      },
      status: {
        label: 'Status',
        position: 4,
        getter: 'goodOrderStatuses',
        itemText: 'title',
      },
      ext_number: {
        label: 'Document number',
        position: 4,
      },
    },
    goodOrderRuleFilters: {
      unit_id: {
        label: 'Unit',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      store_id: {
        label: 'Store',
        position: 1,
        getter: 'getStores',
        itemText: 'title',
      },
      group_id: {
        label: 'Group',
        position: 2,
        getter: 'goodGroups',
      },
    },
    equipmentTypeFilters: {
      title: {
        label: 'Title',
        position: 0,
      },
      'places.id': {
        label: 'Places',
        position: 1,
        getter: 'equipmentPlaces',
        itemText: 'title',
      },
    },
    menu: {
      settings: 'Settings',
      logout: 'Logout',
    },
    sessionMenuLocale: {
      openSession: 'Open session',
      closeSession: 'Close session',
    },
    fileMaxSizeText: 'Maximum upload file size - 2 Mb',
    fileUploadedMessage: 'File successfully uploaded',
    fileUploadErrorMessage: 'File upload error',
    fileFormatErrorMessage: 'File format error or document with this number already loaded!',
    bookingSource: {
      site: 'Site',
      crm: 'CRM',
      aggregator: 'Aggregator',
    },
    moveToCategory: 'Move to category',
    saved: 'Saved!',
    duration: 'Duration',
    deleteWindow: 'Delete window "$date"?',
    deleteEmployer: 'Delete employer $employer?',
    deleteService: 'Delete service $service?',
    deleteServiceCategory: 'Delete service category $category?',
    deleteWorkPosition: 'Delete work position $position?',
    deleteBooking: 'Delete booking $booking?',
    deleteCustomer: 'Delete customer $customer?',
    deleteAddress: 'Delete address $1?',
    deleteUnit: 'Delete unit $unit?',
    deleteAnalyticsReport: 'Delete report $report?',
    windowWithoutInterval: 'Window: "$begin_at", doesn\'t have any intervals!',
    windowsNotFound: 'Windows not found',
    goodGive: 'Material give-out',
    goodGives: 'Materials give-out',
    goodGiveNotFound: 'Material not found',
    goodGiveNotIssued: 'Material not issued',
    goodGiveAdded: 'Material added',
    goodGiveAlreadyIssued: 'Material already issued',
    goodGiveIsObsolete: 'Material is obsolete',
    goodGiveInOtherUnit: 'Material in other unit',
    goodGiveBarcodeInUse: 'Barcode is in use',
    goodGiveBarcodeError: 'Barcode error',
    goodGiveIssued: 'Materials issued ($1 pcs)',
    goodGiveTaken: 'Materials taken ($1 pcs)',
    goodGiveChanged: 'Barcodes changed ($1 pcs)',
    goodGiveWrittenOffTitle: 'Write off saved',
    goodGiveWrittenOff: 'Materials written off ($1 pcs)',
    goodGiveScaleError: 'Scales error! ',
    goodOrderOk: 'Ordered',
    goodOrderError: 'Order error!',
    goodOrderLeft: 'Failed to order $1 goods.',
    intervalNumber: '# interval',
    minIntervalsRebook: 'Minimum time intervals for rebook:',
    dateMonthYearFormat: 'DD.MM.YYYY',
    paymentNotExist: 'No payment',
    bookingHistoryIsEmpty: 'Booking history is empty',
    smsHistoryIsEmpty: 'SMS history is empty',
    customersWillBeHere: 'customers will be here',
    actionStartAt: 'Action start:',
    summary: 'Summary',
    objectName: 'Name',
    objectTypes: {
      'App\\Models\\Booking': {
        name: 'Booking',
        action_name: 'booking',
        fields: {
          status_id: 'status',
          user_id: 'user',
          duration: 'duration',
          comment: 'comment',
        },
      },
      'App\\Models\\Company': {
        name: 'Company',
        action_name: 'company',
        fields: {
          first_name: 'first name',
          last_name: 'last name',
          middle_name: 'middle name',
        },
      },
      'App\\Models\\Employer': {
        name: 'Employer',
        action_name: 'employer',
        fields: {
          first_name: 'first name',
          last_name: 'last name',
          middle_name: 'middle name',
          email: 'email',
          phone: 'phone',
          status: 'status',
          unit_id: 'unit',
        },
      },
      'App\\Models\\Service': {
        name: 'Service',
        action_name: 'service',
        fields: {
          service_category_id: 'service category',
          parent_service_id: 'parent',
          title: 'title',
          title_online: 'title online',
          title_cashier: 'title cashier',
          article: 'article',
          barcode: 'barcode',
          duration: 'duration',
        },
      },
      'App\\Models\\ServiceCategory': {
        name: 'Service category',
        action_name: 'category',
        fields: {
          title: 'title',
        },
      },
      'App\\Models\\ServicePrice': {
        name: 'Service price',
        action_name: 'price',
        fields: {
          unit_id: 'unit',
          company_id: 'company',
          service_id: 'service',
          begin_at: 'begin at',
          end_at: 'end at',
          price: 'price',
        },
      },
      'App\\Models\\ServiceResource': {
        name: 'Service resource',
        action_name: 'resource',
        fields: {
          service_id: 'service',
          company_id: 'company',
          type: 'type',
          count: 'count',
        },
      },
      'App\\Models\\Unit': {
        name: 'Unit',
        action_name: 'unit',
        fields: {
          location_type: 'location type',
          location_id: 'location',
          company_id: 'company',
          name: 'name',
          address: 'address',
          latitude: 'latitude',
          longitude: 'longtitude',
          time_sampling: 'time sampling',
        },
      },
      'App\\Models\\UnitGroup': {
        name: 'Unit group',
        action_name: 'group',
        fields: {
          name: 'name',
        },
      },
      'App\\Models\\UnitSchedule': {
        name: 'Unit schedule',
        action_name: 'schedule',
        fields: {
          unit_id: 'unit',
          company_id: 'company',
          begin_at: 'begin at',
          schedule: 'schedule',
        },
      },
      'App\\Models\\Window': {
        name: 'Window',
        action_name: 'window',
        fields: {
          unit_id: 'unit',
          employer_id: 'employer',
          employer_schedule_id: 'employer schedule',
          workplace_id: 'workplace',
          booking_id: 'booking',
          begin_at: 'begin at',
          end_at: 'end at',
          duration_original: 'duration original',
          duration: 'duration',
        },
      },
    },
    errors: {
      authorization: 'Authorization',
      authorizationException: 'Authorization Error. Invalid phone or password',
      refreshToken: 'Refresh Token',
      forbiddenException: `Not enough permissions`,
      notSuperUserException: 'You are not super user',
      windowNotFound: 'Window Not Found',
      smsGateException: 'SMS gate error',
      authenticationException: 'Unauthenticated',
      modelNotFoundException: 'Model Not Found',
      tokenExpiredException: 'Expired token',
      employerNotFoundException: 'Employer not found',
      employerIncorrectPasswordException: 'Incorrect password',
      notFoundException: 'Review not found',
      scheduleAlreadyApprovedException: 'Already approved',
      scheduleWorkplaceWindowEmptyException: 'Workplace window empty',
      scheduleTooSmallException: 'Schedule too small',
      scheduleWorkplaceNotAvailableException: 'Workplace not available',
      scheduleDeleteExistBookingException: 'Booking exists',
      scheduleNotFoundException: 'Employer schedule not found',
      employerInGraphWithCategoryException:
        'This employee is already in the schedule with the same categories of services',
      profileInvalidTokenException: 'Invalid token',
      windowUnknownTypeException: 'Unknown type',
      bookingWindowNoServicesException: 'Window not include services',
      bookingWindowAlreadyUsedException: 'Window already used',
      bookingServicesNotFoundException: 'Services not found',
      bookingTooManyWindowsException: 'Too many windows in request',
      bookingStatusTypeNotFoundException: 'Status type not found, check flow',
      bookingServicesWithoutPriceException: 'Services without prices',
      employerDublicate: 'Duplicate field value',
      networkError: 'Problem connecting to server',
    },
  },
  ru: {
    error: 'Ошибка',
    saved: 'Сохранение',
    noDataText: 'Ничего не найдено',
    successRemove: 'Успешно удалено',
    successRestore: 'Успешно восстановлено',
    successSave: 'Успешно сохранено',
    errorSavingMessage: 'Ошибка сохранения',
    errorDeletingMessage: 'Ошибка удаления',
    errorRestoreMessage: 'Ошибка восстановления',
    errorOrderSumNotMatch: 'Суммы услуг и оплат не совпадают',
    errorOrderHasNoPayments: 'Не указана оплата',
    errorOrderHasNoUser: 'Не выбран клиент',
    errorOrderHasNoItems: 'Не заданы услуги',
    errorOrderUnitId: 'Не выбрана студия',
    errorOrderHasNoEmployer: 'Для одной или нескольких услуг не указан мастер',
    forbiddenExceptionOrders: `Недостаточно прав для редактирования ОУ`,
    withoutFinishDate: 'Без даты окончания',
    errorCreatingEmployer: 'Ошибка создания сотрудника',
    errorCreatingCompany: 'Ошибка создания компании',
    errorAddingCompanyPhoto: 'Ошибка добавления фотографии',
    errorDeletingCompanyPhoto: 'Ошибка удаления фотографии',
    certificateNotFound: 'Сертификат не найден',
    certificateIsTooYoung: 'Нельзя обналичивать сертификат в день продажи',
    saleIsTooOld: 'Сертификат может быть применен спустя сутки после покупки',
    certificateLoadingError: 'Ошибка загрузки сертификатов',
    certificateReedem: 'Сертификат уже погашен',
    certificateSaled: 'Сертификат уже продан',
    certificateNotSaled: 'Сертификат ещё не продан',
    smsHistory: {
      date: 'Дата',
      type: 'Тип',
      price: 'Стоимость',
      messageLength: 'Количество символов',
      senderNumber: 'Номер отправителя',
      receiverNumber: 'Номер получателя',
      message: 'Сообщение',
      status: 'Статус',
      noDataMessage: 'Сообщений пока нет',
    },
    bookingStatusHistory: {
      headers: {
        updatedAt: 'Дата изменения',
        user: 'Кто изменил',
        what: 'Что изменили',
        before: 'До',
        after: 'После',
      },
      dictionary: {
        id: 'Номер заявки',
        unit_id: 'Студия',
        unit: 'Студия',
        end_at: 'Дата окончания заявки',
        begin_at: 'Начало заявки',
        user_id: 'Клиент',
        user: 'Клиент',
        author_id: 'Оформил заявку',
        author: 'Оформил заявку',
        duration: 'Длительность заявки',
        comment: 'Комментарий',
        status_id: 'Статус',
        status: 'Статус',
        company_id: 'Компания',
        company: 'Компания',
        special_master: 'Запись к определенному мастеру',
        booking_source_id: 'Источник заявки',
        total: 'Сумма',
      },
      noDataText: 'У этой заявки отсутствует история',
    },
    orderStatusHistory: {
      headers: {
        updatedAt: 'Дата изменения',
        user: 'Кто изменил',
        before: 'До',
        after: 'После',
      },
      dictionary: {
        unit_id: 'Студия',
        unit: 'Студия',
        end_at: 'Дата окончания ОУ',
        begin_at: 'Начало ОУ',
        user_id: 'Клиент',
        user: 'Клиент',
        author_id: 'Оформил ОУ',
        author: 'Оформил ОУ',
        creator: 'Ответственнный',
        total: 'Сумма',
        sum: 'Сумма',
        booking: 'Номер заявки',
        duration: 'Длительность ОУ',
        comment: 'Комментарий',
        status_id: 'Статус',
        status: 'Статус',
        company_id: 'Компания',
        company: 'Компания',
        special_master: 'Запись к определенному мастеру',
        source_id: 'Источник ОУ',
        check_printed_at: 'Печать чека',
        sync_to_1c_at: 'Синхронизация ОУ с 1C',
        payment_type: 'Тип оплаты',
        employer: 'Мастер',
        item: 'Услуга',
        item_type: 'Номер сертификата',
        price: 'Сумма',
        info: 'Информация',
        params: 'Номер сертификата',
        sms_sent_at: 'Отправка смс',
        payed: 'Оплачено',
        done_force: 'ОУ закрыто без проверки',
        promotion: 'Акция',
        discount: 'Скидка',
      },
      noDataText: 'У этой ОУ отсутствует история',
      itemTypeTranslation: {
        'App\\Models\\Good': 'Товары',
        'App\\Models\\Service': 'Услуги',
      },
    },
    feedbackStatusHistory: {
      headers: {
        updatedAt: 'Дата изменения',
        user: 'Кто изменил',
        before: 'До',
        after: 'После',
      },
      dictionary: {
        vote: 'Оценка',
        related: 'related',
        source: 'Источник',
        status: 'Статус',
        comment: 'Комментарий',
        comment_internal: 'Комментарий Отдела качества',
        unit: 'Студия',
        vote_other: 'Оценки администратора',
      },
      noDataText: 'У этого отзыва отсутствует история',
      itemTypeTranslation: {
        'App\\Models\\Employer': 'Мастеру',
        'App\\Models\\Order': 'Салону',
      },
    },
    smsHistoryFilters: {
      created_at: {
        label: 'Дате создания',
        position: 0,
      },
      phone: {
        label: 'Телефон',
        position: 1,
      },
      status: {
        label: 'Статус',
        position: 2,
        getter: 'smsStatuses',
      },
    },
    employerValidation: {
      email: 'Пользователь с таким email уже существует',
      phone: 'Пользователь с таким телефоном уже существует',
    },
    serviceTemplates: 'Шаблоны услуг',
    companies: 'Компании',
    serviceTemplatesView: 'Шаблон услуг',
    smsSendedForMany: 'Указанным клиентам были отправлены SMS-сообщения.',
    smsSendedForOne: 'SMS-сообщение было отправлено на номер',
    smsNotSended: 'SMS-сообщение не может быть отправлено , не указан номер клиента.',
    windowNoDataText: 'По данным условиям доступных окон не найдено. Попробуйте повторить поиск с другими параметрами',
    name: 'Имя',
    title: 'Название',
    emailConfirmed: 'Ваш Email подтверждён',
    emailDenied: 'Ваш Email отклонён',
    newFeedbackTitle: 'Новый отзыв',
    feedbackTitle: 'Отзыв: $id',
    loginLabel: 'Авторизация',
    loginErrorLabel: 'У вас не корректный браузер',
    loginBtnLabel: 'Войти',
    errorLoginText: 'Неправильный логин и/или пароль',
    serviceTitle: 'Название услуги',
    serviceCategoryTitle: 'Категория услуги',
    phone: 'Номер телефона',
    phoneNumber: 'Номер телефона',
    email: 'Email',
    password: 'Пароль',
    rememberMeLabel: 'Запомнить меня',
    employer: 'Сотрудник',
    employers: 'Сотрудники',
    push: 'Рассылка PUSH-уведомлений',
    feedbacks: 'Отзывы',
    claims: 'Переделки',
    candidates: 'Автоподбор кандидатов',
    newEmployer: 'Новый сотрудник',
    newBooking: 'Новая заявка',
    newUnit: 'Новое подразделение',
    newCustomer: 'Новый клиент',
    id: 'ID',
    workplaces: 'Рабочие места',
    workplacesName: 'Рабочее место',
    workplaceServiceCategory: 'Категория услуги',
    deleteWorkplace: 'Удалить рабочее место: $item?',
    studioAndEmployer: 'Студия/Сотрудник',
    position: 'Должность',
    text: 'Текст',
    unit: 'Место работы',
    status: 'Статус',
    rating: 'Рейтинг',
    code: 'Код',
    article: 'Артикул',
    codeAndArticle: 'Код/Артикул',
    categoryAndService: 'Категория/Услуга',
    price: 'Цена',
    nominalDuration: 'Номинальная длительность',
    services: 'Услуги',
    service: 'Услуга',
    goods: 'Товары',
    good: 'Товар',
    newGood: 'Новый товар',
    deleteGood: 'Удалить товар: $good?',
    goodGroups: 'Группы товаров',
    goodGroup: 'Группа товаров',
    newGoodGroup: 'Новая группа товаров',
    deleteGoodGroup: 'Удалить группу товаров: $1?',
    goodBarcodeFound: 'Штрихкод уже использован: $1',
    goodFlow: 'Движение товаров',
    deleteGoodFlow: 'Удалить документ: #$1?',
    goodFlowBarcodeNotFound: 'Штрихкод не найден: $1',
    goodFlowGoodAdded: 'Товар добавлен: $1 — $2 шт.',
    goodFlowValidation: {
      goodWithdrawRemains: 'Нельзя произвести списание. проверьте остатки',
    },
    goodRemains: 'Остатки товаров',
    goodRemain: 'Остатки товара',
    deleteGoodRemain: 'Удалить номенклатуру «$1» со склада: $2 ?',
    goodInvoices: 'Импорт товарных накладных',
    goodInvoiceUpload: 'Загрузите накладную',
    goodInvoice: 'Товарная накладная',
    deleteInvoice: 'Удалить накладную: $item?',
    processInvoice: 'Создать документ по накладной: $num от $dat?',
    processWarning: 'Внимание, будут созданы новые номенклатуры товаров — $num шт.!',
    importInvoiceValidation: {
      fileFormat: 'Ошибка формата файла!',
      duplicateNumber: 'Документ с таким номером уже загружен',
    },
    goodInvents: 'Инвентаризация товаров',
    goodInvent: 'Инвентаризация',
    deleteInvent: 'Удалить инвент: $item?',
    processInvent: 'Создать документ по инвенту: #$num?',
    addGoodsToInvent: 'Добавить все недостающие товары со склада: $name?',
    inventItemNumber: {
      shortage: 'Недостача',
      equality: 'Норма',
      excess: 'Излишек',
      deleted: 'Удалён',
    },
    goodInventGoodAdded: 'Товар добавлен: $1 — $2 шт.',
    goodInventGoodUpdated: 'Товар обновлён: $1 — $2 шт.',
    goodOrderValidation: {
      orderError: 'Ошибка заказа!',
      emptyOrder: 'Товары не заказаны!',
      unitNotFound: 'Подразделение не найдено!',
      resultError: 'Ошибка запроса',
    },
    goodOrders: 'Заказы товаров',
    goodOrder: 'Заказ товаров',
    deleteOrder: 'Вы хотите подтвердить удаление заказа?',
    sendOrder:
      'После подтверждения заказ будет отправлен для обработки в «Пилки Шоп». Вы хотите подтвердить отправку заказа?',
    goodsStandard: 'Стандарт наполнения',
    equipmentType: 'Тип оборудования',
    equipmentTypes: 'Типы оборудования',
    equipmentTypeNew: 'Новый тип оборудования',
    deleteEquipmentType: 'Удалить тип оборудования: $item?',
    newService: 'Новая услуга',
    newWorkPosition: 'Новая должность',
    first_name: 'Имя',
    last_name: 'Фамилия',
    middle_name: 'Отчество',
    customers: 'Список клиентов',
    customerName: 'Имя',
    customerPhone: 'Телефон',
    customerEmail: 'E-mail',
    customerValidation: {
      phone: 'Клиент с данным номером телефона уже существует',
    },
    dashboardTitle: 'Отчёты (Альфа-версия)',
    calendarTitle: 'Календарь записи',
    addBooking: 'Добавить заявку',
    calendarSearch: 'Поиск по календарю',
    permissionTranslations: {
      'App\\Models\\Unit': 'Подразделения',
      'App\\Models\\UnitRevenuePlan': 'Планы',
      'App\\Models\\Company': 'Компании',
      'App\\Models\\Employer': 'Сотрудники',
      'App\\Models\\Workplace': 'Рабочие места',
      'App\\Models\\WorkPosition': 'Должности',
      'App\\Models\\ServicePrice': 'Цены',
      'App\\Models\\Booking': 'Заявки',
      'App\\Models\\EmployerSchedule': 'График работы сотрудников',
      'App\\Models\\User': 'Клиенты',
      'App\\Models\\OrderReview': 'Отзывы',
      'App\\Models\\ServiceCategory': 'Категории услуг',
      'App\\Models\\ServiceTemplate': 'Шаблоны услуг',
      'App\\Models\\Service': 'Услуги',
      'App\\Models\\Good': 'Товары',
      'App\\Models\\GoodGroup': 'Группы товаров',
      'App\\Models\\GoodFlow': 'Движение товаров',
      'App\\Models\\GoodRemain': 'Остатки товаров',
      'App\\Models\\GoodGive': 'Выдача материалов',
      'App\\Models\\GoodInvoice': 'Товарные накладные',
      'App\\Models\\GoodInvent': 'Инвентаризация товаров',
      'App\\Models\\GoodOrder': 'Заказ товаров',
      'App\\Models\\GoodOrderRule': 'Правила автозаказа',
      'App\\Models\\Equipment\\EquipmentType': 'Типы оборудования',
      'App\\Models\\Order': 'Оказание услуг',
      'App\\Models\\CashOrder': 'РКО/ПКО',
      'App\\Models\\Salary': 'Зарплаты',
      'App\\Models\\CashRegister': 'ККМ',
      'App\\Models\\CashOrderBasis': 'Кассовые ордеры. Статья основание',
      'App\\Models\\CashOrderOperation': 'Кассовые ордеры. Вид операции',
      'App\\Models\\BankAccount': 'Банковские счета',
      'App\\Models\\Contractor': 'Контрагенты',
      'App\\Models\\AnalyticsReports': 'Аналитика',
      'App\\Models\\AnalyticsData': 'Аналитика. Разделы',
      DASHBOARD_PERMISSIONS: 'Dashboard',
      'App\\Models\\Audit': 'Журнал изменения системы',
      'App\\Models\\SmsLog': 'Журнал SMS сообщений',
      'App\\Models\\Window': 'Календарь',
      'App\\Models\\TicketGroup': 'Тикеты. Группы',
      'App\\Models\\Ticket': 'Обращения',
      'App\\Models\\Payment': 'Оплаты',
      'App\\Models\\EmployerFingerprintCheckin': 'Приход и уход сотрудников',
      'App\\Models\\Review': 'Отзывы',
      'App\\Models\\EmployerSchedulesPlanning': 'Планируемый график',
      'App\\Models\\Certificate': 'Сертификаты',
      'App\\Models\\ExchangeSum': 'Размен',
      'App\\Models\\Discount': 'Скидки',
      'App\\Models\\EmployerSalaryBase': 'Зарплата. Индивидуальные параметры',
      'App\\Models\\EmployerNews': 'Новости',
      'App\\Models\\Promotion': 'Акции',
      'App\\Models\\EmployerAbsenceWork': 'График отсутствия на рабочем мест',
      'App\\Models\\Claim': 'Переделки',
      'App\\Models\\UserClaim': 'Переделки - всегда включено',
      NOTIFY_PERMISSIONS: 'Уведомления',
      'App\\Models\\SpecialOffer': 'Специальные предложения',
      'App\\Models\\Image': 'Фотоработы',
      'App\\Models\\Segment': 'Сегменты',
      'App\\Models\\News': 'Новости',
      'App\\Models\\NailDesign': 'Дизайн ногтей',
      'App\\Models\\Banner': 'Баннер',
      'App\\Models\\Voucher': 'Промокоды',
      'App\\Models\\OrderEditBan': 'Запрет на редактирование ОУ',
      'App\\Models\\GoodOptimalQty': 'Оптимальное количество материалов',
      'App\\Models\\GoodGiveUse': 'Учёт использования товаров',
      'App\\Models\\WaitingListBooking': 'Лист ожидания',
      'App\\Models\\ClubCard': 'Клубная карта',
      'App\\Models\\ClubCardType': 'Тип клубной карты',
      'App\\Models\\UnitSetting': 'Расширенные настройки салонов',
      'App\\Models\\StoreReview': 'Отзывы о приложении',
      'App\\Models\\CheckinLog': 'Аутентификация на смену',
      'App\\Models\\Checkin\\CheckinLog': 'Аутентификация на смену',
      'App\\Models\\UnitKpiPlanPedicure': 'План по педикюру',
      'App\\Models\\UnitKpiPlanManicure': 'План по маникюру',
      'App\\Models\\UnitKpiPlan': 'План',
      'App\\Models\\CallCenterWorkplace': 'Телефония',
      BONUSES: 'Бонусы',
    },
    smsEventMap: {
      phone_change: 'Изменение телефона',
      'App\\Notifications\\EmployerResetPassword': 'Изменение пароля',
      phone_confirm: 'Подтверждение телефона',
      booking_done: 'Заявка выполнена',
      'App\\Notifications\\BookingOrdered': 'Заявка выполнена',
    },
    callType: {
      incoming: 'Входящий',
      outcoming: 'Исходящий',
    },
    varnishesFilters: {
      status: {
        label: 'Статус',
      },
      unit_id: {
        label: 'Студия',
        getter: 'units',
      },
      'user.id': {
        label: 'Клиент (ФИО, телефон)',
      },
      'employer.id': {
        label: 'Мастер',
      },
      good_id: {
        label: 'Id лака',
      },
      'good.title': {
        label: 'Название лака',
      },
      updated_at: {
        label: 'Последнее изменение',
        position: 4,
        view: Vue.config.VIEW_DATEPICKER,
      },
    },
    employerFilters: {
      id: {
        label: 'Сотрудник (ФИО, телефон)',
        position: 0,
      },
      unit_id: {
        label: 'Место работы',
        position: 1,
        getter: 'units',
      },
      work_position_id: {
        label: 'Должность',
        position: 2,
        getter: 'workPositions',
        itemText: 'title',
        itemValue: 'id',
      },
      // 'employerStatus.id': {
      //   label: 'Статус',
      //   position: 3,
      //   getter: 'employerStatuses'
      // },
      'employerState.id': {
        label: 'Состояние',
        position: 3,
        getter: 'employerStates',
      },
      hr_manager_id: {
        label: 'Менеджеру по персоналу',
        position: 6,
        getter: 'hrEmployers',
      },
      interview_at: {
        label: 'Дата собеседования',
        position: 7,
      },
      deleted_at: {
        label: 'Состояние',
        position: 8,
        itemsYesNo: [
          { text: 'Не удалён', value: 0 },
          { text: 'Удалён', value: 1 },
        ],
        permission: 'EMPLOYEE_RESTORE',
      },
    },
    customerFilters: {
      id: {
        label: 'Клиент (ФИО, телефон)',
        position: 0,
      },
      email: {
        label: 'Email',
        position: 2,
      },
      deleted_at: {
        label: 'Состояние',
        position: 3,
        itemsYesNo: [
          { text: 'Не удален', value: 0 },
          { text: 'Удален', value: 1 },
        ],
        permission: 'CUSTOMER_RESTORE',
      },
    },
    bookings: {
      bookinglist: 'Список заявок',
      unit: 'Студия',
      number: 'Номер заявки',
      user: 'Клиент',
      price: 'Сумма',
      userPhone: 'Телефон клиента',
      employer: 'Мастер',
      statusId: 'Статус заявки',
      startTime: 'Время начала ',
      created: 'Создана',
      source: 'Источник заявки',
    },
    workplaceFilters: {
      'units.name': {
        label: 'Студия',
        position: 0,
      },
      'units.workplaces.serviceCategories.title': {
        label: 'Категория услуги',
        position: 1,
      },
      name: {
        label: 'Город',
        position: 2,
      },
    },
    schedulesFilter: {
      name: 'Сотрудник (ФИО, телефон)',
      first_name: 'Имя',
      last_name: 'Фамилия',
      middle_name: 'Отчество',
      service_categories: 'Виды оказываемых услуг',
      work_positions: 'Должности',
      employer_status_id: 'Статус',
      is_reserve: 'Резерв',
      is_visit: 'Выездные сотрудники',
    },
    newServiceCategory: 'Новая категория услуг',
    serviceFilters: {
      title: {
        label: 'Услуга',
        position: 0,
      },
    },
    serviceCategoryFilters: {
      title: {
        label: 'Категория',
        position: 0,
      },
      'services.title': {
        label: 'Услуга',
        position: 1,
      },
    },
    logFilters: {
      created_at: {
        label: 'Дата',
        view: Vue.config.VIEW_DATEPICKER,
      },
      event: {
        label: 'Событие',
        position: 2,
        getter: 'logEvents',
      },
      model_id: {
        label: 'Oбъект',
        getter: 'objectTypes',
      },
      model_type: {
        label: 'Тип данных',
        getter: 'logModelTypes',
      },
      user_id: {
        label: 'Пользователь',
        getter: 'employers',
      },
    },
    newWorkPlace: 'Новое рабочее место',
    logs: 'Журнал изменений',
    action: 'Действие',
    created: 'Создание',
    createAt: 'Создана',
    updated: 'Редактирование',
    deleted: 'Удаление',
    object: 'Тип данных',
    user: 'Пользователь',
    customer: 'Клиент',
    time: 'Время',
    index: 'Проиндексирована',
    field: 'Поле',
    before: 'До',
    after: 'После',
    city: 'Город',
    unitName: 'Наименование',
    unitType: 'Тип подразделения',
    noteType: 'Тип записи',
    linkNote: 'Ссылка на запись',
    linkProfile: 'Ссылка на профиль',
    units: 'Подразделения',
    unitRevenuePlans: 'Планы',
    unitRevenuePlanValidation: {
      duplicateRevenuePlan: 'Такой план уже создан!',
    },
    unitRevenuePlanError: 'Ошибка',
    deleteUnitRevenuePlan: 'Удалить план: $name за $date ?',
    employerStatuses: {
      0: 'Работает',
      1: 'Наемный',
      2: 'Уволен',
    },
    educations: {
      0: 'Высшее',
      1: 'Среднее',
      2: 'Незаконченное высшее',
    },
    analytics: 'Аналитика',
    analyticsFilters: {
      title: {
        label: 'Название',
        position: 0,
      },
    },
    orderFilters: {
      unit_id: {
        label: 'Салон',
        position: 0,
        getter: 'units',
      },
      'items.employer_id': {
        label: 'Мастер',
        position: 1,
      },
      'items.item_id': {
        label: 'Услуга',
        position: 2,
        getter: 'services',
      },
      user_id: {
        label: 'Клиент',
        position: 3,
      },
      'payments.payment_type': {
        label: 'Тип оплаты',
        position: 4,
        getter: 'paymentTypes',
      },
      created_at: {
        label: 'Дата работ',
        position: 5,
        view: Vue.config.VIEW_DATEPICKER,
      },
      id: {
        label: 'Номер',
        position: 6,
      },
      status: {
        label: 'Статус',
        position: 8,
        view: Vue.config.VIEW_SELECT,
        getter: 'orderDoneStatuses',
      },
      'items.item_type': {
        label: 'Предмет продажи',
        position: 9,
        getter: 'orderItemTypes',
      },
    },
    certificateListFilters: {
      number: {
        label: 'Номер сертификата',
        position: 0,
      },
    },
    certificateFilters: {
      number: {
        label: 'Номер сертификата',
        position: 0,
        type: 'like',
      },
      sale_unit_id: {
        label: 'Студия продажи',
        position: 0,
        getter: 'units',
        itemText: 'name',
        itemValue: 'id',
      },
      redeem_unit_id: {
        label: 'Студия гашения',
        position: 1,
        getter: 'units',
        itemText: 'name',
        itemValue: 'id',
      },
      sale_at: {
        label: 'Дата продажи',
        position: 2,
        view: Vue.config.VIEW_DATEPICKER,
      },
      redeem_at: {
        label: 'Дата гашения',
        position: 3,
        view: Vue.config.VIEW_DATEPICKER,
      },
    },
    workPositions: 'Должности и права доступа',
    workPositionFilters: {
      title: {
        label: 'Должность',
        position: 0,
      },
      company_id: {
        label: 'Компания',
        position: 1,
        getter: 'companies',
      },
    },
    cityFilters: {
      name: {
        label: 'Город',
        position: 0,
      },
      'units.name': {
        label: 'Салон',
        position: 1,
      },
    },
    unitFilters: {
      name: {
        label: 'Название',
        position: 0,
      },
      address: {
        label: 'Адрес',
        position: 1,
      },
      type: {
        label: 'Тип',
        position: 2,
        getter: 'unitTypesFilter',
      },
    },
    unitRevenuePlanFilters: {
      unit_id: {
        label: 'Подразделение',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      begin_at: {
        label: 'Дата',
        position: 1,
        view: Vue.config.VIEW_DATEPICKER_MONTH,
      },
    },
    goodFilters: {
      id: {
        label: 'Наименование',
        position: 0,
      },
      good_group_id: {
        label: 'Группа',
        position: 1,
        getter: 'goodGroups',
      },
      good_brand_id: {
        label: 'Производитель',
        position: 2,
        getter: 'goodBrands',
      },
    },
    goodGroupFilters: {
      id: {
        label: 'Наименование',
        position: 0,
      },
      products: {
        label: 'Товары поставщика',
        position: 1,
        itemsYesNo: [
          { text: 'Нет', value: 0 },
          { text: 'Есть', value: 1 },
        ],
      },
    },
    goodFlowFilters: {
      issued_at: {
        label: 'Дата',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      id: {
        label: 'Номер',
        position: 1,
      },
      good_flow_type_id: {
        label: 'Вид операции',
        position: 2,
        getter: 'flowTypes',
      },
      good_flow_status_id: {
        label: 'Статус',
        position: 3,
        getter: 'flowStatuses',
      },
      flow_unit_id: {
        label: 'Подразделение',
        position: 4,
        getter: 'units',
        itemText: 'name',
      },
      flow_contractor_id: {
        label: 'Контрагент',
        position: 5,
        getter: 'contractors',
        itemText: 'name_full',
        itemValue: 'id',
        view: Vue.config.VIEW_SELECT,
      },
      comment: {
        label: 'Комментарий',
        position: 6,
      },
      deleted_at: {
        label: 'Состояние',
        position: 6,
        itemsYesNo: [
          { text: 'Не удалён', value: 0 },
          { text: 'Удалён', value: 1 },
        ],
        permission: 'RESTORE_PRODUCT_FLOW',
      },
    },
    goodRemainFilters: {
      unit_id: {
        label: 'Подразделение',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      'good.good_group_id': {
        label: 'Группа',
        position: 2,
        getter: 'goodGroups',
        itemText: 'name',
      },
      'good.good_brand_id': {
        label: 'Производитель',
        position: 3,
        getter: 'goodBrands',
        itemText: 'name',
      },
      'good.id': {
        label: 'Наименование',
        position: 4,
      },
      updated_at: {
        label: 'Последнее изменение',
        position: 5,
        view: Vue.config.VIEW_DATEPICKER,
      },
      store_id: {
        label: 'Склад',
        position: 1,
        itemText: 'name',
        getter: 'getStores',
      },
    },
    goodGiveFilters: {
      unit_id: {
        label: 'Подразделение',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      'employer.id': {
        label: 'Сотрудник',
        position: 1,
      },
      'good.id': {
        label: 'Материал',
        position: 2,
      },
      status: {
        label: 'Статус',
        position: 3,
        itemText: 'name',
        getter: 'goodGiveStatuses',
      },
      barcode: {
        label: 'Штрихкод',
        position: 4,
      },
      updated_at: {
        label: 'Дата',
        position: 5,
        view: Vue.config.VIEW_DATEPICKER,
      },
    },
    goodInvoiceFilters: {
      created_at: {
        label: 'Дата загрузки',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      issued_at: {
        label: 'Дата документа',
        position: 1,
        view: Vue.config.VIEW_DATEPICKER,
      },
      number: {
        label: 'Номер',
        position: 2,
      },
      status: {
        label: 'Статус',
        position: 3,
        getter: 'invoiceStatuses',
        itemText: 'name',
      },
      unit_id: {
        label: 'Подразделение',
        position: 4,
        getter: 'units',
        itemText: 'name',
      },
      'employer.id': {
        label: 'Сотрудник',
        position: 5,
      },
    },
    goodInventFilters: {
      updated_at: {
        label: 'Дата',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      status: {
        label: 'Статус',
        position: 3,
        getter: 'inventStatuses',
        itemText: 'name',
      },
      unit_id: {
        label: 'Подразделение',
        position: 4,
        getter: 'units',
        itemText: 'name',
      },
      store_id: {
        label: 'Склад',
        position: 5,
        getter: 'getStores',
        itemText: 'name',
      },
      'employer.id': {
        label: 'Сотрудник',
        position: 6,
      },
    },
    goodOrderFilters: {
      updated_at: {
        label: 'Дата',
        position: 0,
        view: Vue.config.VIEW_DATEPICKER,
      },
      unit_id: {
        label: 'Подразделение',
        position: 1,
        getter: 'units',
        itemText: 'name',
      },
      store_id: {
        label: 'Склад',
        position: 2,
        getter: 'getStores',
        itemText: 'title',
      },
      employer_id: {
        label: 'Ответственный',
        position: 3,
      },
      status: {
        label: 'Статус',
        position: 4,
        getter: 'goodOrderStatuses',
        itemText: 'title',
      },
      ext_number: {
        label: 'Номер документа',
        position: 5,
      },
    },
    goodOrderRuleFilters: {
      unit_id: {
        label: 'Подразделение',
        position: 0,
        getter: 'units',
        itemText: 'name',
      },
      store_id: {
        label: 'Склад',
        position: 1,
        getter: 'getStores',
        itemText: 'title',
      },
      group_id: {
        label: 'Группы',
        position: 2,
        getter: 'goodGroups',
      },
    },
    equipmentTypeFilters: {
      title: {
        label: 'Наименование',
        position: 0,
      },
      'places.id': {
        label: 'Места',
        position: 1,
        getter: 'equipmentPlaces',
        itemText: 'title',
      },
    },
    menu: {
      status: 'Cтатус',
      settings: 'Настройки',
      logout: 'Выйти',
    },
    sessionMenuLocale: {
      openSession: {
        name: 'Открыть смену',
        action: 'open',
        color: 'green',
      },
      closeSession: {
        name: 'Закрыть смену',
        action: 'close',
        color: 'red',
      },
      xReport: {
        name: 'Промежуточная сверка',
        action: 'reportX',
      },
      inventory: {
        name: 'Инкассация',
        action: 'inventory',
        color: 'red',
      },
      authenticationFinger: {
        name: 'Аутентификация по отпечатку',
        action: 'authentication',
      },
    },
    helpTopMenu: {
      openSession: {
        name: 'Пособие по работе с CRM',
        router: 'crm-instruction',
        externalRout: false,
      },
      closeSession: {
        name: 'Часто задаваемые вопросы',
        router: 'crm-faq',
        externalRout: false,
      },
      activeSprint: {
        name: 'Спринт IT-отдела',
        router: 'https://docs.google.com/spreadsheets/d/1JaDXus6HlwE7cwGNpV0lmP1amgf3xg9-fDEkMrikKhA/edit?usp=sharing',
        externalRout: true,
      },
      informationDisclosure: {
        name: 'Раскрытие информации',
        showModal: true,
      },
      organizationalStructureOfTheCompany: {
        name: 'Организационная структура компании',
        router:
          'https://docs.google.com/spreadsheets/d/1WAGmjUKtU0H3iQ6TLBbf7ea_lvKYOyigD9-I4DKsyeA/edit#gid=789283610',
        externalRout: true,
      },
    },

    fileMaxSizeText: 'Максимальный размер файла для загрузки - 2 МБ',
    fileButtonText: 'Выберите файл для загрузки на компьютере',
    fileUploadedMessage: 'Файл успешно загружен',
    fileUploadErrorMessage: 'Ошибка загрузки файла',
    emptyPhotoCache: 'Пока не добавлена ни одна фотография',
    bookingSource: {
      site: 'Сайт',
      crm: 'CRM',
      aggregator: 'Приложение клиента',
      personal_account_site: 'Личный кабинет сайта',
      personal_account_site: 'ЛК сайта',
      CRM: 'CRM',
      'Web Site': 'Сайт',
      'Client application': 'Приложение клиента',
      Tablet: 'Планшет',
      'Call center': 'КЦ',
      Unit: 'Студия',
      'Booking approve feature': 'Подтверждение заявки',
      'Personal account on the site': 'Личный кабинет на сайте',
      'Telegram bot': 'Телеграм бот',
      telegram_mini_app: 'Mini App',
    },
    moveToCategory: 'Перейти в категорию',
    savedMessage: 'Сохранено!',
    savedErrorMessage: 'Ошибка сохранения!',
    refreshedMessage: 'Обновлено!',
    refreshedErrorMessage: 'Ошибка обновления!',
    sentToProcessMessage: 'Отправлено на обработку.',
    availableTemplateService: 'Доступные шаблоны услуг',
    autoSelectSaveRuleMessage: 'Правило автоподбора успешно добавлено!',
    autoSelectSaveRuleMessageError: 'Не удалось сохранить правило автоподбора',
    autoSelectDeleteRuleMessage: 'Правило автоподбора успешно удалено!',
    autoSelectDeleteRuleMessageError: 'Не удалось удалить правило автоподбора',
    avatarSavedMessage: 'Новый аватар успешно сохранён',
    avatarSavedErrorMessage: 'Ошибка сохранения аватара',
    documentsSaveErrorMessage: 'Ошибка сохранения документов',
    documentsLoadingErrorMessage: 'Ошибка загрузки документов',
    loadingError: 'Ошибка загрузки',
    errorEmployerDoesNotHaveThisCategory: 'Сотрудник не выполняет текущие услуги',
    doNotHavePhoto: 'Не прикреплена ни одна фотография',
    phoneSavedMessage: 'Новый номер телефона успешно сохранён',
    phoneSavedErrorMessage: 'Номер из СМС указан не верно',
    emailSendMessage: 'Письмо отправлено по адресу: ',
    emailTokenError: 'Токен указан не верно',
    emailResetSavedMessage: 'Email успешно изменён!',
    discrepancyOrder: 'Расхождение суммы услуг и суммы оплат',
    shortAddress: 'Название для СМС',
    smsSendMessage: 'СМС отправлено на номер: ',
    passwordSavedMessage: 'Пароль успешно изменён ',
    passwordNotValiddMessage: 'Текущий пароль введён неверно',
    deleteMessage: 'Удалено!',
    deleteErrorMessage: 'Ошибка удаления!',
    hasBookingMessage: 'На этот интервал уже есть заявка!',
    notFoundMessage: 'Не существует!',
    duration: 'Длительность',
    priceActual: 'Цена',
    qty: 'Количество',
    deleteWindow: 'Удалить окно "$date"?',
    deleteEmployer: 'Удалить сотрудника $employer?',
    deleteService: 'Удалить услугу $service?',
    deleteServiceCategory: 'Удалить категорию услуг $category?',
    deleteWorkPosition: 'Удалить должность $position?',
    deleteBooking: 'Удалить заявку $booking?',
    deleteCustomer: 'Удалить клиента $customer?',
    deleteAddress: 'Удалить адрес $1?',
    deleteUnit: 'Удалить Студию $unit?',
    deleteAnalyticsReport: 'Удалить отчёт $report?',
    windowWithoutInterval: 'Окно с началом: "$begin_at", не имеет ни одного интервала!',
    createWindowMessage: 'Новое окно успешно создано',
    createWindowMessageError: 'Ошибка. Не удалось создать новое окно',
    emptyIntervalWorkplace: 'Интервалы отсутствуют',
    windowCancelMin: 'Минимальный размер обрезания при отмене заявки, который может остаться:',
    windowSplitIndent: 'Отступ от предыдущего окна при создании записи для следующего:',
    windowSplitMin: 'Разделение окна при записи:',
    noWindowQuantumSize: 'Предоставлять выбор времени при подборе через промежуток, равный:',
    noWindowQuantumSizeTitle: 'Подбор времени для безоконного режима',
    scheduleTypeNull:
      'При постановке сотрудника в график работы будут созданы временные окна, соответствующие интервалам <b>рабочего места</b>. Окна влияют на доступное время для подбора заявки',
    scheduleTypeOne:
      'При постановке сотрудника в график работы будут созданы временные окна, соответствующие <b>собственным интервалам сотрудника</b>. Окна влияют на доступное время для подбора заявки',
    scheduleTypeTwo: 'Свободный режим постановки сотрудника в график и подбора заявок',
    minIntervalsRebook: 'Минимальные интервалы времени для  повторного заказа:',
    feedbackEmpty: 'Клиент не оставил текстовое сообщение',
    allAsRead: 'Отметить все как прочитанные',
    lookAllNotifications: 'См. все оповещения',
    schedule: {
      serviceCategory: {
        required: 'Поле обязательно для заполнения',
      },
      workplace: {
        required: 'Поле обязательно для заполнения',
      },
      rules: {
        date: 'Неверный интервал.',
        service_category_id: 'Необходимо выбрать услугу',
        workplace_id: 'Необходимо выбрать рабочее место',
        workplaceBusy: 'Для некоторых дней рабочее место недоступно',
        workplaceIsUsage: 'Это рабочее место уже выбрано',
        workplaceIsEmpty: 'Рабочих мест нет',
        serviceCategoryIsEmpty: 'Нет доступных услуг для выбора',
        serviceCategoryBadMaster: 'У мастера не заданы услуги',

        passportNotExist: 'Отсутствует паспорт',
        avatarNotExist: 'Отсутствует аватар пользователя',
        fingerprintsNotExist: 'Отсутствует отпечаток пальцев',
      },
      save: {
        success: 'Сохранено!',
        error: 'Произошла ошибка, во время сохранения.',
        workplaceBusy: 'На {date} рабочее место занято ',
        errorDeleteSchedule: 'Произошла ошибка, во время удаления.',
        clientError: 'Ошибка валидации.',
      },
      setPerTemplate: {
        errorWorkplace: 'Рабочие места закончились',
      },
      approve: {
        1210: 'Окна уже были сформированы',
        1211: 'Отсутствуют интервалы рабочего места',
        1212: 'Длительность смены меньше, чем индивидуальные окна',
        1213: 'Рабочие места недоступны',
        1214: 'На эту дату уже сформированы окна',

        missingApproveIDs: 'Все окна уже были сформированы',
        success: 'Окна успешно сформированы',
        successAndNot: 'Окна частично сформированы',
        error: 'Окна не сформированы',
      },
    },
    windowsNotFound: 'По заданным условиям не найдено ни одного интервала',
    emptyFields: 'Одно или несколько полей заполнены неверно',
    goodGive: 'Выдача материала',
    goodGives: 'Выдача материалов',
    goodGiveNotFound: 'Материал не найден',
    goodGiveNotIssued: 'Материал не выдан',
    goodGiveAdded: 'Материал добавлен',
    goodGiveAlreadyIssued: 'Материал уже выдан',
    goodGiveIsObsolete: 'Материал списан',
    goodGiveWrongBooking: 'Материал выдан на другую заявку',
    goodGiveWrongEmployer: 'Материал выдан другому мастеру',
    goodGiveEmptyEmployer: 'Не указан мастер',
    goodGiveWrongGoodType: 'Материал данного типа не требуется',
    goodGiveInOtherUnit: 'Материал в другом подразделении',
    goodGiveBarcodeInUse: 'Штрихкод уже использован',
    goodGiveBarcodeError: 'Ошибочный штрихкод',
    goodGiveIssued: 'Материалы выданы ($1 шт)',
    goodGiveTaken: 'Материалы получены ($1 шт)',
    goodGiveChanged: 'Штрихкоды заменены ($1 шт)',
    goodGiveWrittenOffTitle: 'Списание сохранено',
    goodGiveWrittenOff: 'Материалы списаны ($1 шт)',
    goodGiveScaleError: 'Ошибка весов! ',
    goodOrderOk: 'Заказано',
    goodOrderError: 'Ошибка заказа!',
    goodOrderLeft: 'Не заказано несколько товаров ($1 шт).',
    intervalNumber: 'Интервал',
    dateMonthYearFormat: 'DD.MM.YYYY',
    paymentNotExist: 'Оплата еще не была произведена',
    bookingHistoryIsEmpty: 'Истории заказов пока нет',
    smsHistoryIsEmpty: 'Истории SMS пока нет',
    customersWillBeHere: 'Здесь будут отображаться клиенты',
    actionStartAt: 'Расписание действует с',
    summary: 'Итого',
    objectName: 'Объект',
    objectTypes: {
      'App\\Models\\Booking': {
        name: 'Заявка',
        action_name: 'Заявки',
        fields: {
          status_id: 'Статус',
          user_id: 'Пользователь',
          duration: 'Продолжительность',
          comment: 'Комментарий',
        },
      },
      'App\\Models\\Company': {
        name: 'Компания',
        action_name: 'Компании',
        fields: {
          name: 'Название',
        },
      },
      'App\\Models\\Employer': {
        name: 'Сотрудник',
        action_name: 'Сотрудника',
        fields: {
          first_name: 'Имя',
          last_name: 'Фамилия',
          middle_name: 'Отчество',
          email: 'Email',
          phone: 'Телефон',
          status: 'Статус',
          employer_price_category_id: 'Категория мастера',
          schedule_type: 'Способ постановки в график',
          hr_manager: 'Менеджер по персоналу',
          employer_status_id: 'Статус',
          work_position_id: 'Должность',
          start_work_at: 'Дата начала работы',
          city_id: 'Город',
          unit_id: 'Студия',
          metro_id: 'Метро',
          education: 'Образование',
          can_login: 'Заходил в систему',
          region_id: 'Регион',
          company_id: 'Компания',
          country_id: 'Страна',
          birthday_at: 'Дата рождения',
          end_work_at: 'Дата окончания работы',
          interview_at: 'Дата собеседования',
          is_superuser: 'Суперпользователь',
          voices: 'Кол-во оценок',
          rating_calculate: 'Рейтинг',
          is_reserve: 'Мастер резерва',
          hunting_resource_id: 'Ресурс подбора',
          work_parallel: '4 руки',
          password: 'Был сброшен пароль',
          self_employed: 'Самозанятый',
          is_resident: 'Тип сотрудника',
        },
      },
      'App\\Models\\EmployerSchedule': {
        name: 'Расписание',
        action_name: 'расписания',
        fields: {
          employer_id: 'сотрудник',
          begin_at: 'начало',
          end_at: 'конец',
          unit_id: 'салон',
          workplace_id: 'рабочее место',
          service_category_id: 'категория',
        },
      },
      'App\\Models\\User': {
        name: 'Клиент',
        action_name: 'Клиента',
        fields: {
          first_name: 'имя',
          last_name: 'фамилия',
          middle_name: 'отчество',
          email: 'email',
          phone: 'телефон',
        },
      },
      'App\\Models\\Service': {
        name: 'Услуга',
        action_name: 'услуги',
        fields: {
          service_category_id: 'категория',
          parent_service_id: 'родительская услуга',
          title: 'название',
          title_online: 'название online',
          title_cashier: 'название в чеке',
          article: 'артикул',
          barcode: 'штрих-код',
          duration: 'продолжительность',
        },
      },
      'App\\Models\\ServiceCategory': {
        name: 'Категория услуги',
        action_name: 'категории',
        fields: {
          title: 'название',
        },
      },
      'App\\Models\\ServicePrice': {
        name: 'Цена услуги',
        action_name: 'цены',
        fields: {
          unit_id: 'студия',
          company_id: 'компания',
          service_id: 'услуга',
          begin_at: 'начало',
          end_at: 'конец',
          price: 'цена',
        },
      },
      'App\\Models\\ServiceResource': {
        name: 'Ресурс услуги',
        action_name: 'ресурса',
        fields: {
          service_id: 'услуга',
          company_id: 'компания',
          type: 'тип',
          count: 'количество',
        },
      },
      'App\\Models\\Unit': {
        name: 'Студия',
        action_name: 'студии',
        fields: {
          location_type: 'тип населенного пункта',
          location_id: 'населенный пункт',
          company_id: 'компания',
          name: 'название',
          address: 'адрес',
          latitude: 'широта',
          longitude: 'долгота',
          time_sampling: 'время',
        },
      },
      'App\\Models\\UnitGroup': {
        name: 'Группа студий',
        action_name: 'группы',
        fields: {
          name: 'название',
        },
      },
      'App\\Models\\UnitSchedule': {
        name: 'Расписание студии',
        action_name: 'расписания',
        fields: {
          unit_id: 'студия',
          company_id: 'компания',
          begin_at: 'начало',
          schedule: 'расписание',
        },
      },
      'App\\Models\\Window': {
        name: 'Окно',
        action_name: 'окна',
        fields: {
          unit_id: 'студия',
          employer_id: 'сотрудник',
          employer_schedule_id: 'расписание сотрудника',
          workplace_id: 'рабочее место',
          booking_id: 'заявка',
          begin_at: 'начало',
          end_at: 'конец',
          duration_original: 'продолжительность original',
          duration: 'продолжительность',
        },
      },
    },
    errors: {
      removing: 'Ошибка удаления',
      scheduleStatistic: 'Ошибка загрузки статистики',
      scheduleStatisticIsEmpty: 'Статистика за этот день отсутствует',
      authorization: 'Авторизация',
      authorizationException: `Ошибка авторизации <br> Неверно введён логин и/или пароль`,
      refreshToken: 'Ошибка обновления токена',
      forbiddenException: `Недостаточно прав`,
      notSuperUserException: 'Вы не суперпользователь',
      windowNotFound: 'Окно не найдено',
      smsGateException: 'Ошибка ввода СМС кода',
      authenticationException: 'Пользователь не авторизован',
      modelNotFoundException: 'Сущность не найдена',
      tokenExpiredException: 'Истекший токен',
      employerNotFoundException: 'Сотрудник не найден',
      employerIncorrectPasswordException: 'Текущий пароль пользователя введён неверно',
      notFoundException: 'Не найден',
      scheduleAlreadyApprovedException: 'Расписание уже утвержденно',
      scheduleWorkplaceWindowEmptyException: 'Пустое место на рабочем месте',
      scheduleTooSmallException: 'График работы слишком мал',
      scheduleWorkplaceNotAvailableException: 'Рабочее место недоступно',
      scheduleDeleteExistBookingException: 'Заявка уже существует',
      scheduleNotFoundException: 'Не найден график работы сотрудника',
      employerInGraphWithCategoryException: 'Это сотрудник уже в графике с такими же категориями услуг',
      profileInvalidTokenException: 'Неправильное значение',
      windowUnknownTypeException: 'Неизвестный тип',
      bookingWindowNoServicesException: 'Окно не включает услуги',
      bookingLoadError: 'Ошибка зарузки заявки',
      bookingStatusesLoadError: 'Ошибка зарузки статусов заявки',
      bookingWindowAlreadyUsedException: 'Окно уже использовано',
      bookingServicesNotFoundException: 'Услуга не найдена',
      bookingTooManyWindowsException: 'Слишком много окон в одном запросе',
      bookingStatusTypeNotFoundException: 'Тип статуса не найден',
      bookingServicesWithoutPriceException: 'Услуга не содержит поле Цена',
      employerDublicate: 'Повторяющееся значение поля',
      networkError: 'Проблема соединения с сервером',
      savingGoodError: 'Ошибка сохранения товара',
      salaryGenerationError: 'Ошибка создания зарплаты',
      salaryError: 'Отчет не найден',
    },
    vouchers: {
      title: 'Промокоды',
      type: 'Тип привязки',
      types: {
        city: 'Город',
        company: 'Компания',
        unit: 'Студия',
        user: 'Клиент',
        segment: 'Сегмент',
        claim: 'Переделка',
      },
      attach: 'Привязан к',
      code: 'Код',
      sum: 'Сумма',
      expiresAt: 'Активен до',
      createdBy: 'Создатель',
      createdAt: 'Дата создания',
      servicesAndGoods: 'Товары и услуги',
      usedCount: 'Использовано',
    },
  },
}

Vue.config.scheduleTypes = {
  default: 0,
  individual: 1,
}

Vue.config.employerCategoryStatus = {
  statusCreated: 0,
  statusUpdated: 1,
  statusDelete: 2,
}

Vue.config.selectedTypesBlocking = {
  permanently: 0,
  blockAt: 1,
  blockAfter: 2,
}

Vue.config.employerTypeOptions = [
  {
    value: 1,
    name: 'Резидент',
  },
  {
    value: 0,
    name: 'Нерезидент',
  },
]

Vue.config.errors = {
  authorization: 1004,
  authorizationException: 1010,
  refreshToken: 1012,
  forbiddenException: 1030,
  notSuperUserException: 1031,
  windowNotFound: 1211,
  smsGateException: 2000,
  authenticationException: 401,
  modelNotFoundException: 404,
  tokenExpiredException: 1005,
  employerNotFoundException: 1200,
  employerIncorrectPasswordException: 1201,
  notFoundException: 1200,
  scheduleAlreadyApprovedException: 1210,
  scheduleWorkplaceWindowEmptyException: 1211,
  scheduleTooSmallException: 1212,
  scheduleWorkplaceNotAvailableException: 1213,
  scheduleDeleteExistBookingException: 1214,
  scheduleNotFoundException: 1215,
  employerInGraphWithCategoryException: 1216,
  profileInvalidTokenException: 1220,
  windowUnknownTypeException: 1300,
  bookingWindowNoServicesException: 1400,
  bookingWindowAlreadyUsedException: 1401,
  bookingServicesNotFoundException: 1402,
  bookingTooManyWindowsException: 1403,
  bookingStatusTypeNotFoundException: 1410,
  bookingServicesWithoutPriceException: 1404,
  employerDublicate: 23000,
}

Vue.config.productionTip = false

const PAYMENTS_STATUS = {
  user_pending: 'новый',
  provider_pending: 'обработка платежа',
  success: 'успешно (ооплачен)',
  fail: 'ошибка (неоплачен)',
  refund: 'возврат',
  cancel: 'отмена',
}

Vue.config.TICKETS_STATUSES_TITLES = TICKETS_STATUSES_TITLES
Vue.config.TICKETS_STATUSES = TICKETS_STATUSES
Vue.config.PAYMENT_STATUSES_TITLES = PAYMENT_STATUSES_TITLES
Vue.config.PAYMENT_STATUSES = PAYMENT_STATUSES
Vue.config.PAYMENT_TYPES_TITLES = PAYMENT_TYPES_TITLES
Vue.config.PAYMENT_TYPES_OBJECT = PAYMENT_TYPES_OBJECT
Vue.config.PAYMENT_TYPES_OBJECT_FILTER = PAYMENT_TYPES_OBJECT_FILTER
Vue.config.PAYMENTS_STATUS = PAYMENTS_STATUS
Vue.config.PAYMENT_TYPES = PAYMENT_TYPES
Vue.config.ORDER_ITEM_TYPE_TITLES = ORDER_ITEM_TYPE_TITLES
Vue.config.ORDER_DONE_STATUSES = ORDER_DONE_STATUSES
Vue.config.ORDER_PAYMENT_STATUSES = ORDER_PAYMENT_STATUSES

Vue.config.feedback_statuses = FEEDBACK_STATUSES
Vue.config.claim_statuses = CLAIM_STATUSES
Vue.config.booking_source = BOOKING_SOURCE

Vue.config.TYPE_NOTIFICATIONS = TYPE_NOTIFICATIONS

Vue.config.WORK_POSITIONS = WORK_POSITIONS
Vue.config.WORK_POSITION_TYPES = WORK_POSITION_TYPES
Vue.config.EMPLOYER_PHOTOS_TYPES = EMPLOYER_PHOTOS_TYPES
const ALL_PERMISSIONS_ARRAY = Object.values(PERMISSIONS_CONSTANTS)
Vue.config.permissions = {
  DENIED_CONSTANTS,
  PERMISSIONS_CONSTANTS,
  SUPER_ADMIN_PERMISSIONS: ALL_PERMISSIONS_ARRAY,
  ADMIN_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.CUSTOMERS,
    PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMER,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.WAITING_LIST,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.SCHEDULE,
    PERMISSIONS_CONSTANTS.LIST_ACTIVE_FINGERPRINT,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,

    PERMISSIONS_CONSTANTS.PRODUCTS_USAGE,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT,

    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.RKO,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,
    PERMISSIONS_CONSTANTS.FINANCIAL_OPERATIONS,

    PERMISSIONS_CONSTANTS.ANALYTICS_SECTION,
    PERMISSIONS_CONSTANTS.ANALYTICS,
    PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    PERMISSIONS_CONSTANTS.ANALYTIC,

    PERMISSIONS_CONSTANTS.GOODS,
    PERMISSIONS_CONSTANTS.GOODS_SECTION,
    PERMISSIONS_CONSTANTS.PRODUCT,
    PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICE,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_INVOICE,
    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,

    DENIED_CONSTANTS.RKO_ONLY_DS_OPERATION,
    DENIED_CONSTANTS.EMPLOYEE_ONLY_INFO_SERVICES_HISTORY_SHEDULE,
    DENIED_CONSTANTS.EMPLOYER_INFO_MAIN_INFO_CONTACTS_BLOCK,
  ],
  ADMIN_TOP_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS,
    PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMER,
    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.RKO,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,
    PERMISSIONS_CONSTANTS.FINANCIAL_OPERATIONS,

    PERMISSIONS_CONSTANTS.GOODS,
    PERMISSIONS_CONSTANTS.GOODS_SECTION,
    PERMISSIONS_CONSTANTS.PRODUCT,
    PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICE,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_INVOICE,

    PERMISSIONS_CONSTANTS.SCHEDULE,

    PERMISSIONS_CONSTANTS.ANALYTICS,
    PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    PERMISSIONS_CONSTANTS.ANALYTIC,
    PERMISSIONS_CONSTANTS.ANALYTICS_SECTION,

    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,

    DENIED_CONSTANTS.RKO_ONLY_DS_OPERATION,
    DENIED_CONSTANTS.EMPLOYEE_ONLY_INFO_SERVICES_HISTORY_SHEDULE,
    DENIED_CONSTANTS.EMPLOYER_INFO_MAIN_INFO_CONTACTS_BLOCK,
  ],
  MANAGER_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.CALENDAR,

    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,

    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.RKO,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,
    PERMISSIONS_CONSTANTS.FINANCIAL_OPERATIONS,

    PERMISSIONS_CONSTANTS.GOODS,
    PERMISSIONS_CONSTANTS.GOODS_SECTION,
    PERMISSIONS_CONSTANTS.PRODUCT,
    PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
    PERMISSIONS_CONSTANTS.PRODUCTS_USAGE,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICE,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_INVOICE,

    PERMISSIONS_CONSTANTS.SCHEDULE,

    PERMISSIONS_CONSTANTS.ANALYTICS,
    PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    PERMISSIONS_CONSTANTS.ANALYTIC,
    PERMISSIONS_CONSTANTS.ANALYTICS_SECTION,

    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,

    DENIED_CONSTANTS.RKO_ONLY_DS_OPERATION,
    DENIED_CONSTANTS.EMPLOYEE_ONLY_INFO_SERVICES_HISTORY_SHEDULE,
    DENIED_CONSTANTS.EMPLOYER_INFO_MAIN_INFO_CONTACTS_BLOCK,
  ],
  DISTRICT_MANAGER_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.CALENDAR,

    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,

    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.RKO,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,
    PERMISSIONS_CONSTANTS.FINANCIAL_OPERATIONS,

    PERMISSIONS_CONSTANTS.GOODS,
    PERMISSIONS_CONSTANTS.GOODS_SECTION,
    PERMISSIONS_CONSTANTS.PRODUCT,
    PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICE,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_INVOICE,

    PERMISSIONS_CONSTANTS.SCHEDULE,

    PERMISSIONS_CONSTANTS.ANALYTICS,
    PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    PERMISSIONS_CONSTANTS.ANALYTIC,
    PERMISSIONS_CONSTANTS.ANALYTICS_SECTION,

    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,

    DENIED_CONSTANTS.RKO_ONLY_DS_OPERATION,
    DENIED_CONSTANTS.EMPLOYEE_ONLY_INFO_SERVICES_HISTORY_SHEDULE,
    DENIED_CONSTANTS.EMPLOYER_INFO_MAIN_INFO_CONTACTS_BLOCK,
  ],
  CALL_CENTER_EMPLOYEE_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.CUSTOMERS,
    PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
    PERMISSIONS_CONSTANTS.CUSTOMER,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.SCHEDULE,
    PERMISSIONS_CONSTANTS.TELEPHONY,
    PERMISSIONS_CONSTANTS.CALL_CENTER,
    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    DENIED_CONSTANTS.FEEDBACKS_DISABLE_EDIT,
  ],
  CALL_CENTER_TOP_EMPLOYEE_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,

    PERMISSIONS_CONSTANTS.CUSTOMERS,
    PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
    PERMISSIONS_CONSTANTS.CUSTOMER,

    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.CANDIDATES,

    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.SCHEDULE,
    PERMISSIONS_CONSTANTS.TELEPHONY,
    PERMISSIONS_CONSTANTS.CALL_CENTER,
    PERMISSIONS_CONSTANTS.STORAGE,
    PERMISSIONS_CONSTANTS.SCHOOL,
    PERMISSIONS_CONSTANTS.AFFILIATES,
    PERMISSIONS_CONSTANTS.REQUEST,
    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,

    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,
    DENIED_CONSTANTS.FEEDBACKS_DISABLE_EDIT,
  ],
  CALL_CENTER_MANAGER_PERMISSIONS: ALL_PERMISSIONS_ARRAY,
  CALL_CENTER_ALTERNATE_MANAGER_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS,
    PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
    PERMISSIONS_CONSTANTS.CUSTOMER,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.SERVICES,
    PERMISSIONS_CONSTANTS.NEW_SERVICES,
    PERMISSIONS_CONSTANTS.NEW_SERVICE_CATEGORY,
    PERMISSIONS_CONSTANTS.SERVICE_CATEGORY,
    PERMISSIONS_CONSTANTS.SERVICE,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.SMS_HISTORY,
    PERMISSIONS_CONSTANTS.SCHEDULE,
    PERMISSIONS_CONSTANTS.TELEPHONY,
    PERMISSIONS_CONSTANTS.CALL_CENTER,
    PERMISSIONS_CONSTANTS.STORAGE,
    PERMISSIONS_CONSTANTS.SCHOOL,
    PERMISSIONS_CONSTANTS.AFFILIATES,
    PERMISSIONS_CONSTANTS.REQUEST,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,
    PERMISSIONS_CONSTANTS.SERVICES_SECTION,
  ],
  MANAGER_CLIENTS_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.FINANCIAL_OPERATIONS,
    PERMISSIONS_CONSTANTS.CUSTOMERS,
    PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
    PERMISSIONS_CONSTANTS.CUSTOMER,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.LOGS_SECTION,
    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,
    DENIED_CONSTANTS.EMPLOYEE_ONLY_INFO_SERVICES_HISTORY_SHEDULE,
  ],
  ACCOUNTANT_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.FINANCIAL_OPERATIONS,
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.SERVICES,
    PERMISSIONS_CONSTANTS.NEW_SERVICES,
    PERMISSIONS_CONSTANTS.NEW_SERVICE_CATEGORY,
    PERMISSIONS_CONSTANTS.SERVICE_CATEGORY,
    PERMISSIONS_CONSTANTS.SERVICE,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.SCHEDULE,
    PERMISSIONS_CONSTANTS.ANALYTICS,
    PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    PERMISSIONS_CONSTANTS.ANALYTIC,
    PERMISSIONS_CONSTANTS.GOODS,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT,
    PERMISSIONS_CONSTANTS.PRODUCT,
    PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_FLOW,
    PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
    PERMISSIONS_CONSTANTS.PRODUCTS_USAGE,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICE,
    PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
    PERMISSIONS_CONSTANTS.NEW_PRODUCT_INVOICE,
    PERMISSIONS_CONSTANTS.RKO,
    PERMISSIONS_CONSTANTS.PKO,
    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,
    PERMISSIONS_CONSTANTS.ZP,
    PERMISSIONS_CONSTANTS.UNIT,
    PERMISSIONS_CONSTANTS.UNITS,
    PERMISSIONS_CONSTANTS.NEW_UNIT,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.SERVICES_SECTION,
    PERMISSIONS_CONSTANTS.GOODS_SECTION,
    PERMISSIONS_CONSTANTS.ANALYTICS_SECTION,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.UNITS_SECTION,
  ],
  CHIEF_ACCOUNTANT_PERMISSIONS: ALL_PERMISSIONS_ARRAY,
  HR_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.CANDIDATES,
    PERMISSIONS_CONSTANTS.SCHEDULE,
    PERMISSIONS_CONSTANTS.CALL_CENTER,
    PERMISSIONS_CONSTANTS.STORAGE,
    PERMISSIONS_CONSTANTS.SCHOOL,
    PERMISSIONS_CONSTANTS.AFFILIATES,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.UNITS_SECTION,
    PERMISSIONS_CONSTANTS.UNITS,
    PERMISSIONS_CONSTANTS.ANALYTICS,
    PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    PERMISSIONS_CONSTANTS.ANALYTIC,
    PERMISSIONS_CONSTANTS.ANALYTICS_SECTION,
  ],
  CHIEF_HR_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.CANDIDATES,
    PERMISSIONS_CONSTANTS.SERVICES,
    PERMISSIONS_CONSTANTS.NEW_SERVICES,
    PERMISSIONS_CONSTANTS.NEW_SERVICE_CATEGORY,
    PERMISSIONS_CONSTANTS.SERVICE_CATEGORY,
    PERMISSIONS_CONSTANTS.SERVICE,
    PERMISSIONS_CONSTANTS.UNITS,
    PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.SCHEDULE,
    PERMISSIONS_CONSTANTS.ANALYTICS,
    PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
    PERMISSIONS_CONSTANTS.ANALYTIC,
    PERMISSIONS_CONSTANTS.ANALYTICS_SECTION,
    PERMISSIONS_CONSTANTS.CALL_CENTER,
    PERMISSIONS_CONSTANTS.STORAGE,
    PERMISSIONS_CONSTANTS.SCHOOL,
    PERMISSIONS_CONSTANTS.AFFILIATES,
    PERMISSIONS_CONSTANTS.REQUEST,
    PERMISSIONS_CONSTANTS.SMS_HISTORY,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.SERVICES_SECTION,
    PERMISSIONS_CONSTANTS.UNITS_SECTION,

    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.LOGS_SECTION,
  ],
  QUALITY_CONTROL_PERMISSIONS: [
    PERMISSIONS_CONSTANTS.SETTINGS_SECTION,
    PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
    PERMISSIONS_CONSTANTS.CALENDAR,
    PERMISSIONS_CONSTANTS.BOOKINGS,
    PERMISSIONS_CONSTANTS.NEW_BOOKING,
    PERMISSIONS_CONSTANTS.BOOKING,
    PERMISSIONS_CONSTANTS.BOOKINGS_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS,
    PERMISSIONS_CONSTANTS.CUSTOMER,
    PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
    PERMISSIONS_CONSTANTS.EMPLOYEES,
    PERMISSIONS_CONSTANTS.NEW_EMPLOYEE,
    PERMISSIONS_CONSTANTS.EMPLOYEE,
    PERMISSIONS_CONSTANTS.AFFILIATES,
    PERMISSIONS_CONSTANTS.REQUEST,
    PERMISSIONS_CONSTANTS.FINANCES_SECTION,
    PERMISSIONS_CONSTANTS.FINANCIAL_SERVICES,
    PERMISSIONS_CONSTANTS.EMPLOYEES_SECTION,
    PERMISSIONS_CONSTANTS.CUSTOMERS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_SECTION,
    PERMISSIONS_CONSTANTS.FEEDBACKS_LIST,
    PERMISSIONS_CONSTANTS.LOGS,
    PERMISSIONS_CONSTANTS.LOGS_SECTION,
    PERMISSIONS_CONSTANTS.SMS_HISTORY,
    DENIED_CONSTANTS.EMPLOYEE_ONLY_INFO_SERVICES_HISTORY_SHEDULE,
  ],
}
Vue.config.NOTIFY_TYPES = Object.entries(NOTIFY_TYPES_TITLES).map(([key, val]) => ({ id: key, name: val }))
Vue.config.NOTIFY_TYPES_TITLES = NOTIFY_TYPES_TITLES
export default Vue
